import { groupBy } from 'lodash';
import { disableDatesForPayCycleEnd1, disableDatesForPayCycleStart1 } from '../utils/helper';
import { Operators } from './appConstants';
import { controlType } from './common';
import { is } from 'date-fns/locale';

/* eslint-disable quotes */
export const employees = [
  { title: 'Avalos, Jose' },
  { title: 'Banegas, Christine' },
  { title: 'Burger, Sabrina' },
  { title: 'Cole, Justin' }
];

export const varianceColumnsPropertyList = [
  {
    name: 'Market',
    key: 'marketName',
    type: 'Child',
    isRequired: true,
    isVisible: true,
    minWidth: 200,
    editConfig: {
      type: 'TextField',
      isEditField: false,
      isAddField: false

    }
  },
  {
    name: 'Department',
    key: 'departmentName',
    type: 'Child',
    isRequired: true,
    isVisible: false,
    minWidth: 200,
    editConfig: {
      type: 'TextField',
      isEditField: false,
      isAddField: false

    },
    hideWhen: [{ key: "allocationType", value: "Property" }],
    notEditWhen: { key: "allocationType", value: "Property" }
  },
  {
    name: 'Division',
    key: 'division',
    type: 'Child',
    minWidth: 200,
    hideWhen: [{ key: "allocationType", value: "Property" }],
    notEditWhen: { key: "allocationType", value: "Property" }
  },
  // {
  //   name: 'Client',
  //   key: 'clientName',
  //   type: 'Child',
  //   isRequired: true,
  //   isVisible: false,
  //   minWidth: 200,
  //   editConfig: {
  //     type: 'TextField',
  //     isEditField: false,
  //     isAddField: false

  //   },
  //   hideWhen: [{ key: "allocationType", value: "Market" }],
  //   notEditWhen: { key: "allocationType", value: "Market" }
  // },
  {
    name: 'Customer / Legal Entity',
    key: 'legalEntity',
    type: 'Child',
    isRequired: true,
    isVisible: true,
    minWidth: 200,
    editConfig: {
      type: 'TextField',
      isEditField: false,
      isAddField: false

    },
    hideWhen: [{ key: "allocationType", value: "Market" }],
    notEditWhen: { key: "allocationType", value: "Market" }
  },
  {
    name: 'Account Code Name',
    key: 'category',
    type: 'Child',
    isRequired: true,
    isVisible: false,
    minWidth: 200,
    editConfig: {
      type: 'TextField',
      isEditField: false,
      isAddField: false
    },
    hideWhen: [{ key: "allocationType", value: "Market" }],
    notEditWhen: { key: "allocationType", value: "Market" }
  },
  // {
  //   name: 'Property Name',
  //   key: 'propertyName',
  //   type: 'Child',
  //   isRequired: true,
  //   isVisible: false,
  //   minWidth: 200,
  //   editConfig: {
  //     type: 'TextField',
  //     isEditField: false,
  //     isAddField: false
  //   },
  //   hideWhen: [{ key: "allocationType", value: "Market" }],
  //   notEditWhen: { key: "allocationType", value: "Market" }
  // },
  {
    name: 'Total Employee Allocation Count',
    key: 'preferredName',
    type: 'Child',
    minWidth: 200,
    isRequired: true,
    isVisible: true,
    editConfig: {
      type: 'TextField',
      isEditField: false,
      isAddField: false
    }
  },
  // {
  //   name: 'Billing Start Date', // 'Billing From',
  //   key: 'billingStartDate',
  //   type: 'Child',
  //   dataFormat: 'Date',
  //   isRequired: true,
  //   isVisible: false,
  //   editConfig: {
  //     type: 'DatePicker',
  //     isEditField: false,
  //     isAddField: false
  //   }
  // },
  // {
  //   name: 'Billing End Date', // 'Billing To',
  //   key: 'billingEndDate',
  //   type: 'Child',
  //   dataFormat: 'Date',
  //   isRequired: true,
  //   isVisible: false,
  //   editConfig: {
  //     type: 'DatePicker',
  //     isEditField: false,
  //     isAddField: false
  //   }
  // },
  // {
  //   name: 'Total Property Allocation %', // 'Allocation %',
  //   key: 'propertyAllocationPercent',
  //   type: 'Child',
  //   isRequired: true,
  //   isVisible: false,
  //   dataFormat: 'DecimalPercent',
  //   hideWhen: [{ key: "allocationType", value: "Market" }],
  //   editConfig: {
  //     type: 'TextField',
  //     isEditField: true,
  //     isAddField: false,
  //     controlWidth: '40px',
  //     isAvoidFormatting: true
  //   }
  // },
  // {
  //   name: 'Total Market Allocation %', // 'Billing %',
  //   key: 'overallMarketAllocationPercent',
  //   type: 'Child',
  //   isRequired: true,
  //   isVisible: false,
  //   dataFormat: 'DecimalPercent',
  //   hideWhen: [{ key: "allocationType", value: "Market" }],
  //   editConfig: {
  //     type: 'TextField',
  //     isEditField: true,
  //     isAddField: false,
  //     controlWidth: '40px',
  //     isAvoidFormatting: true
  //   }
  // },
  // {
  //   name: 'Flat Fee Amount',
  //   key: 'additionalFixedAmount',
  //   type: 'Child',
  //   displayFormat: 'MoneyDecimal',
  //   isVisible: false,
  //   editSortOrder: 16,
  //   editConfig: {
  //     type: 'TextField',
  //     isEditField: true,
  //     isAddField: true,
  //     hideWhen: [{ key: "isReimbursed", value: false }]
  //   },
  //   hideWhen: [{ key: "allocationType", value: "Market" }]
  // },
  {
    name: 'Current Period Property Billing % ', // 'Billing %',
    key: 'propertyBillingPercent',
    type: 'Child',
    isRequired: true,
    isVisible: true,
    dataFormat: 'DecimalPercent',
    hideWhen: [{ key: "allocationType", value: "Market" }],
    editConfig: {
      type: 'TextField',
      isEditField: true,
      isAddField: false,
      controlWidth: '40px',
      isAvoidFormatting: true
    }
  },
  {
    name: 'Prior Period Property Billing % ', // 'Billing %',
    key: 'prevPropertyBillingPercent',
    type: 'Child',
    isRequired: true,
    isVisible: true,
    dataFormat: 'DecimalPercent',
    hideWhen: [{ key: "allocationType", value: "Market" }],
    editConfig: {
      type: 'TextField',
      isEditField: true,
      isAddField: false,
      controlWidth: '40px',
      isAvoidFormatting: true
    }
  },
  {
    name: 'Current Period Allocation %', // 'Billing %',
    key: 'marketAllocationPercent',
    type: 'Child',
    // markRedOrGreen: true,
    isRequired: true,
    isVisible: true,
    dataFormat: 'DecimalPercent',
    hideWhen: [{ key: "allocationType", value: "Property" }],
    editConfig: {
      type: 'TextField',
      isEditField: true,
      isAddField: false
      // isAvoidFormatting: true
    }
  },
  {
    name: 'Prior Period Allocation %', // 'Billing %',
    key: 'prevMarketAllocationPercent',
    type: 'Child',
    // markRedOrGreen: true,
    isRequired: true,
    isVisible: true,
    dataFormat: 'DecimalPercent',
    hideWhen: [{ key: "allocationType", value: "Property" }],
    editConfig: {
      type: 'TextField',
      isEditField: true,
      isAddField: false
      // isAvoidFormatting: true
    }
  },
  // {
  //   name: '',
  //   key: 'allocationId',
  //   type: 'Child',
  //   renderComponent: 'renderActionColumn'
  // },
  // {
  //   name: 'Reimbursement',
  //   key: 'reimburse',
  //   type: 'Child',
  //   dataFormat: 'MoneyDecimal',
  //   isRequired: true,
  //   isVisible: true,
  //   editConfig: {
  //     type: 'TextField',
  //     isEditField: false,
  //     isAddField: false
  //   }
  // },
  {
    name: 'Current Period Reimbursement Amount', // 'Current Reimbursement Amount',
    key: 'reimbursement', // 'reimburse',
    type: 'Child',
    dataFormat: 'MoneyDecimal',
    isSensitive: { key: 'marketId', value: 22 },
    isRequired: true,
    isVisible: true,
    editConfig: {
      type: 'TextField',
      isEditField: false,
      isAddField: false
    }
  },
  {
    name: 'Prior Period Reimbursement Amount',
    key: 'priorPeriodReimburse',
    type: 'Child',
    isRequired: true,
    isVisible: true,
    isSensitive: { key: 'marketId', value: 22 },
    dataFormat: 'MoneyDecimal',
    editConfig: {
      type: 'TextField',
      isEditField: false,
      isAddField: false
    }
  },
  {
    name: '$ Reimbursement Variance',
    key: 'variance',
    type: 'Child',
    dataFormat: 'MoneyDecimal',
    isRequired: true,
    isVisible: true,
    minWidth: 150,
    markRedOrGreen: true,
    editConfig: {
      type: 'TextField',
      isEditField: false,
      isAddField: false
    }
  },
  {
    name: '% Reimbursement Variance',
    key: 'variancePercent',
    type: 'Child',
    dataFormat: 'DecimalPercent',
    isRequired: true,
    isVisible: true,
    markRedOrGreen: true,
    minWidth: 155,
    editConfig: {
      type: 'TextField',
      isEditField: false,
      isAddField: false
    }
  }
];
export const variancePropertyReportConfigList = {
  collapsibleMultilevel: true,
  groupBy: ['marketName', 'departmentName', 'division'],
  showPager: true,
  pagerGrouping: true,
  sorting: false,
  orderBy: 'parentMarketId',
  primaryKey: 'allocationId',
  addExtraSpace: { key: 'parentMarketId', whenGreaterThan: 0 }
};

export const marketColumns = [
  { name: 'Market Name', key: 'marketName', type: 'Parent' },
  { name: 'Legal Entity Name', key: 'marketLegalEntityName', type: 'Parent' },
  { name: 'Address', key: 'address', type: 'Parent' },
  { name: 'Status', key: 'marketStatus', type: 'Parent' },
  { name: 'Department', key: 'typeName', type: 'Child' },
  {
    name: 'Employees Allocated To Base Markets',
    key: 'viewEmployee',
    type: 'Child',
    renderComponent: 'renderActionColumn'
  },
  {
    name: 'Employees Allocated From Other Markets',
    key: 'viewOtherEmployee',
    type: 'Child',
    renderComponent: 'renderActionColumn'
  },
  {
    name: 'Properties',
    key: 'viewProperty',
    type: 'Child',
    renderComponent: 'renderActionColumn'
  }
];

export const MarketPropertyDetailsColumns = [
  { name: 'Property Name', key: 'propertyName', type: 'Parent' },
  { name: 'Address', key: 'address', type: 'Parent' },
  { name: 'City', key: 'city', type: 'Parent' },
  { name: 'Property Type', key: 'propertyTypeName', type: 'Parent' },
  // { name: 'Move In Date', key: 'moveInDate', type: 'Parent', dataFormat: 'Text' },
  { name: 'Employee Count', key: 'employeeCount', type: 'Parent', dataFormat: 'Number' }
];

export const marketConfig = {
  collapsible: true,
  // showCollapsible: true,
  ignoreLength: true,
  groupBy: 'marketName',
  startFromBegining: true,
  showPager: false,
  orderBy: 'parentMarketId',
  showEqualSpace: true,
  addExtraSpace: { key: 'parentMarketId', whenGreaterThan: 0 }
};
export const marketDetailsFormConfig = [
  { key: 'marketName', type: controlType.DropDown, multiple: false },
  { key: 'TypeName', type: controlType.DropDown, multiple: true, columnWidth: 12 }
];

export const propertyColumns = [
  { name: 'Property Name', key: 'propertyName', type: 'Parent' },
  { name: 'Streamline Property Name', key: 'streamlinePropertyName', type: 'Parent' },
  { name: 'Property Type', key: 'propertyTypeName', type: 'Child' },
  { name: 'Property Sub Type', key: 'propertySubTypeName', type: 'Child' },
  { name: 'Market', key: 'marketName', type: 'Child' },
  { name: 'Client', key: 'clientName', type: 'Parent' },
  { name: 'Legal Entity', key: 'legalEntity', type: 'Parent' },
  { name: 'Source Accounting System', key: 'sourceAccountingSystem', type: 'Parent' },
  { name: 'Property Code', key: 'yardiCode', type: 'Parent' },
  { name: 'Address', key: 'address', type: 'Parent' },
  { name: 'City', key: 'city', type: 'Parent' },
  { name: 'State', key: 'state', type: 'Parent' },
  // { name: 'Acquisition Date', key: 'addedOn', type: 'Child', dataFormat: 'Date' },
  { name: 'Department', key: 'departmentName', type: 'Child' },
  { name: 'Allocated Employee Count', key: 'employeeCount', type: 'Child', dataFormat: 'Number' },
  // { name: 'On Site Management', key: 'isOnsiteManagement', type: 'Child' },
  // { name: 'Move In Date', key: 'moveInDate', type: 'Child', format: 'Date' },
  {
    name: 'Action',
    key: 'marketId',
    type: 'Child',
    renderComponent: 'renderActionColumn',
    minWidth: 80
  }
];

export const propertyColumnsPTF = [
  { name: 'Property Name', key: 'propertyName', type: 'Parent' },
  { name: 'Property Type', key: 'propertyTypeName', type: 'Child' },
  { name: 'Property Sub Type', key: 'propertySubTypeName', type: 'Child' },
  { name: 'Market', key: 'marketName', type: 'Child' },
  { name: 'Client', key: 'clientName', type: 'Parent' },
  { name: 'Legal Entity', key: 'legalEntity', type: 'Parent' },
  { name: 'Source Accounting System', key: 'sourceAccountingSystem', type: 'Parent' },
  { name: 'Property Code', key: 'yardiCode', type: 'Parent' },
  { name: 'Address', key: 'address', type: 'Parent' },
  { name: 'City', key: 'city', type: 'Parent' },
  { name: 'State', key: 'state', type: 'Parent' },
  // { name: 'Acquisition Date', key: 'addedOn', type: 'Child', dataFormat: 'Date' },
  { name: 'Allocated Employee Count', key: 'employeeCount', type: 'Child', dataFormat: 'Number' },
  // { name: 'Total SF', key: 'totalSF', type: 'Child', dataFormat: 'moneyNumber' },
  { name: 'Area SF', key: 'areaSF', type: 'Child', dataFormat: 'Number' },
  // { name: "On Site Management", key: "isOnsiteManagement", type: "Child" },
  // { name: 'Move In Date', key: 'moveInDate', type: 'Child', dataFormat: 'Date' },
  {
    name: 'Action',
    key: 'propertyId',
    type: 'Child',
    renderComponent: 'renderActionColumn',
    minWidth: 80
  }
];

// Property columns for Property address table on PTF Detail Report
export const propertyColumnsPTFDetailReport = [
  { name: 'Property Name', key: 'propertyName', type: 'Parent' },
  { name: 'Address', key: 'propertyAddress', type: 'Parent' },
  { name: 'City', key: 'propertyCity', type: 'Parent' },
  { name: 'State', key: 'propertyState', type: 'Parent' },
  { name: 'Zip Code', key: 'propertyZipcode', type: 'Parent' }
];

export const clientContactDetailsColumn = [
  {
    name: '',
    key: 'selectAll',
    type: 'Child',
    renderComponent: 'renderActionColumn',
    renderControls: 'renderControlsColumn',
    minWidth: 80,
    editConfig: {
      type: 'Checkbox',
      isEditField: true,
      isAddField: true,
      toolTip1: 'Select All',
      toolTip2: 'Deselect All',
      name: 'Contacts'
    }
  },
  { name: 'Contact Name', key: 'contactName', type: 'Parent' },
  { name: 'Address', key: 'address', type: 'Parent' },
  { name: 'City', key: 'city', type: 'Parent' },
  { name: 'State', key: 'state', type: 'Parent' },
  { name: 'Zip Code', key: 'zipCode', type: 'Child', dataFormat: 'ZipCode' },
  { name: 'Phone Number', key: 'phoneNumber', type: 'Child', dataFormat: 'Text' },
  { name: 'Email', key: 'email', type: 'Child', dataFormat: 'Text' },
  { name: 'Role', key: 'role', type: 'Child', dataFormat: 'Text' },
  { name: 'Comments', key: 'comments', type: 'Child', dataFormat: 'Text' },
  {
    name: 'Action',
    key: 'propertyId',
    type: 'Child',
    renderComponent: 'renderActionColumn',
    minWidth: 80
  }
];

export const managementFeeColumns = [
  { name: 'Property Name', key: 'managementPropertyName', type: 'Parent', hideWhen: [{ key: "applyToAll", value: true }] },
  { name: 'Legal Entity Name', key: 'legalEntity', type: 'Parent', hideWhen: [{ key: "applyToAll", value: false }] },
  { name: 'Fee Percentage', key: 'feePercentage', type: 'Child', dataFormat: 'DecimalPercent' },
  { name: 'Flat Fee', key: 'flatFee', type: 'Child', dataFormat: 'MoneyDecimal' },
  { name: 'Minimum Fee', key: 'minimumFee', type: 'Parent', dataFormat: 'MoneyDecimal' },
  { name: 'Start date', key: 'startdate', type: 'Parent', dataFormat: 'Date' },
  {
    name: 'Action',
    key: 'recordId',
    type: 'Child',
    renderComponent: 'renderActionColumn',
    minWidth: 80
  }
];
export const ExpenseColumns = [
  { name: 'Property Name', key: 'expensesBillablePropertyName', type: 'Parent' },
  { name: 'Expense(s)', key: 'expenseName', type: 'Child', dataFormat: 'MultiText' },
  {
    name: 'Action',
    key: 'recordId',
    type: 'Child',
    renderComponent: 'renderActionColumn',
    minWidth: 80
  }
];

export const EngineerHourBillingColumns = [
  { name: 'Engineer Hourly Billing Rate', key: 'engineerHourlyBillingRate', type: 'Child', dataFormat: 'MoneyDecimal', hideWhen: [{ key: 'isEngineerHourBilling', value: false }] },
  { name: 'Engineer Overtime Hourly Billing Rate', key: 'engineerOvertimeHourlyBillingRate', type: 'Child', dataFormat: 'MoneyDecimal', hideWhen: [{ key: 'isEngineerHourBilling', value: false }] },
  { name: 'Start date', key: 'engineerHourlyBillingStartDate', type: 'Parent', dataFormat: 'Date' },
  { name: 'End date', key: 'engineerHourlyBillingEndDate', type: 'Parent', dataFormat: 'Date' },
  {
    name: 'Action',
    key: 'recordId',
    type: 'Child',
    renderComponent: 'renderActionColumn',
    minWidth: 80
  }
];

export const readOnlyManagementFeeColumns = [
  { name: 'Property Name', key: 'managementPropertyName', type: 'Parent', hideWhen: [{ key: "applyToAll", value: true }] },
  { name: 'Legal Entity Name', key: 'legalEntity', type: 'Parent', hideWhen: [{ key: "applyToAll", value: false }] },
  { name: 'Fee Percentage', key: 'feePercentage', type: 'Child', dataFormat: 'DecimalPercent' },
  { name: 'Flat Fee', key: 'flatFee', type: 'Child', dataFormat: 'MoneyDecimal' },
  { name: 'Minimum Fee', key: 'minimumFee', type: 'Parent', dataFormat: 'MoneyDecimal' },
  { name: 'Start date', key: 'startdate', type: 'Parent', dataFormat: 'Date' }
];

export const readOnlyClientContactDetailsColumn = [
  { name: 'Contact Name', key: 'contactName', type: 'Parent' },
  { name: 'Address', key: 'address', type: 'Parent' },
  { name: 'City', key: 'city', type: 'Parent' },
  { name: 'State', key: 'state', type: 'Parent' },
  { name: 'Zip Code', key: 'zipCode', type: 'Child', dataFormat: 'ZipCode' },
  { name: 'Phone Number', key: 'phoneNumber', type: 'Child', dataFormat: 'Text' },
  { name: 'Email', key: 'email', type: 'Child', dataFormat: 'Text' },
  { name: 'Role', key: 'role', type: 'Child', dataFormat: 'Text' },
  { name: 'Description', key: 'comments', type: 'Child', dataFormat: 'Text' }

];
export const newManagementFeeColumns = [
  { name: 'Property Name', key: 'ManagementPropertyName', type: 'Parent' },
  { name: 'Fee Percentage', key: 'newFeePercentage', type: 'Child', dataFormat: 'DecimalPercent' },
  { name: 'Flat Fee', key: 'newFlatFee', type: 'Child', dataFormat: 'MoneyDecimal' },
  { name: 'Minimum Fee', key: 'newMinimumFee', type: 'Parent', dataFormat: 'MoneyDecimal' },
  { name: 'Start date', key: 'newStartdate', type: 'Parent', dataFormat: 'Date' },
  {
    name: 'Action',
    key: 'propertyId',
    type: 'Child',
    renderComponent: 'renderActionColumn',
    minWidth: 80
  }
];
export const EmployeeTerminationColumns = [
  { name: 'Employee', key: 'employeeName', type: 'Parent' },
  { name: 'PTF Number', key: 'ptfNumber', type: 'Parent' },
  { name: 'Market', key: 'marketName', type: 'Parent' },
  { name: 'Property', key: 'propertyName', type: 'Parent' },
  { name: 'Termination Date', key: 'terminatedOn', type: 'Parent' },
  // { name: 'Current Overall Property Allocation %', key: 'overallPropertyAllocationPercent', type: 'Parent' },
  { name: 'Total Approved Employee Property Allocation %', key: 'overallPropertyAllocationPercent', type: 'Parent' },
  // { name: 'Current Overall Market Allocation %', key: 'overallMarketAllocationPercent', type: 'Parent' }
  { name: 'Total Approved Employee Market Allocation %', key: 'overallMarketAllocationPercent', type: 'Parent' }
];
export const PedingActionColumns = [
  { name: 'Category', key: 'category', type: 'Parent' },
  { name: 'Description', key: 'categoryDescription', type: 'Parent' },
  { name: 'Approval Status', key: 'approvalStatus', type: 'Parent' },
  { name: 'Requested By', key: 'modifiedBy', type: 'Parent' },
  { name: 'Modified On', key: 'modifiedOn', type: 'Parent', dataFormat: 'Date' },
  // { name: 'Client Name', key: 'clientName', type: 'Parent' },
  {
    name: 'Action',
    key: 'marketId',
    type: 'Child',
    renderComponent: 'renderActionColumn',
    minWidth: 80
  }
];

export const PendingNotificationColumn = [
  { name: 'Title', key: 'feature', type: 'Parent' },
  { name: 'Module', key: 'module', type: 'Parent' },
  { name: 'Notification', key: 'notification', type: 'Parent' },
  { name: 'Created By ', key: 'createdBy', type: 'Parent' },
  { name: 'Created Date', key: 'createdDate', type: 'Parent', dataFormat: 'Date' },
  {
    name: 'Action',
    key: 'notificationMasterId',
    type: 'Child',
    renderComponent: 'renderActionColumn',
    minWidth: 80
  }
];

export const PendingMarketAllocation = [
  {
    name: '',
    key: 'selectAll',
    type: 'Child',
    renderComponent: 'renderActionColumn',
    renderControls: 'renderControlsColumn',
    minWidth: 80,
    editConfig: {
      type: 'Checkbox',
      isEditField: true,
      isAddField: true,
      toolTip1: 'Select All',
      toolTip2: 'Deselect All',
      name: 'Allocation'
    }
  },
  { name: 'Market', key: 'marketName', type: 'Parent' },
  { name: 'Employee Name', key: 'preferredName', type: 'Parent' },
  { name: 'Department', key: 'departmentName', type: 'Parent' },
  {
    name: 'Division',
    key: 'division',
    type: 'Parent'
  },
  {
    name: 'Allocation Start Date',
    key: 'allocationStartDate',
    type: 'Parent',
    dataFormat: 'Date'
  },
  {
    name: 'Allocation End Date',
    key: 'allocationEndDate',
    type: 'Parent',
    dataFormat: 'Date'
  },

  {
    name: 'Allocation Percent',
    key: 'marketAllocationPercent',
    type: 'Parent',
    dataFormat: 'DecimalPercent'
  },
  {
    name: 'Is Reimbursed',
    key: 'isReimbursed',
    dataFormat: 'Boolean'
  },
  {
    name: 'Total Approved Employee Market Allocation %', // 'Current Overall Allocation Percent',
    key: 'overallMarketAllocationPercent',
    type: 'Parent',
    dataFormat: 'DecimalPercent'
  }

];

export const PendingPropertyAllocation = [
  {
    name: '',
    key: 'selectAll',
    type: 'Child',
    renderComponent: 'renderActionColumn',
    renderControls: 'renderControlsColumn',
    minWidth: 80,
    editConfig: {
      type: 'Checkbox',
      isEditField: true,
      isAddField: true,
      toolTip1: 'Select All',
      toolTip2: 'Deselect All',
      name: 'Allocation'
    }
  },
  { name: 'Market', key: 'marketName', type: 'Parent' },
  { name: 'Employee Name', key: 'preferredName', type: 'Parent' },
  { name: 'Department', key: 'departmentName', type: 'Parent' },
  { name: 'PMA Title', key: 'pmaTitle', type: 'Parent' },
  {
    name: "Is Allocate to Legal Entity",
    key: "isAllocatedToLegalEntity",
    dataFormat: 'Boolean'
  },
  { name: 'Property Name', key: 'propertyName', type: 'Parent' },
  { name: 'Property Type', key: 'propertyTypeName', type: 'Parent' },

  {
    name: 'Allocation Start Date',
    key: 'allocationStartDate',
    type: 'Parent',
    dataFormat: 'Date'
  },
  {
    name: 'Allocation End Date',
    key: 'allocationEndDate',
    type: 'Parent',
    dataFormat: 'Date'
  },
  {
    name: 'Billing Start Date',
    key: 'billingStartDate',
    type: 'Parent',
    dataFormat: 'Date'
  },
  {
    name: 'Billing End Date',
    key: 'billingStartDate',
    type: 'Parent',
    showInEditOnly: true,
    dataFormat: 'Date'
  },
  {
    name: 'Allocation Percent',
    key: 'propertyAllocationPercent',
    type: 'Parent',
    dataFormat: 'DecimalPercent'
  },
  {
    name: 'Total Approved Employee Property Allocation %', // 'Current Overall Allocation Percent',
    key: 'overallPropertyAllocationPercent',
    type: 'Parent',
    dataFormat: 'DecimalPercent'
  },
  {
    name: 'Total Approved Employee Property Billing %', // 'Current Overall Billing Percent',
    key: 'overallPropertyBillingPercent',
    type: 'Parent',
    dataFormat: 'DecimalPercent'
  },
  { name: 'Billing Percent', key: 'propertyBillingPercent', type: 'Parent', dataFormat: 'DecimalPercent' },
  {
    name: 'Is Reimbursed',
    key: 'isReimbursed',
    dataFormat: 'Boolean'
  },
  {
    name: 'Flat Rate',
    key: 'additionalFixedAmount',
    type: 'Parent',
    dataFormat: 'MoneyDecimal'
  }
];

export const transitionColumns = [
  { name: 'PTF Number', key: 'ptfNumber', type: 'Parent' },
  { name: 'Market', key: 'marketName', type: 'Parent' },
  // { name: 'Assignment Name', key: 'assignmentName', type: 'Parent' },
  { name: 'Legal Entity / Customer', key: 'assignmentName', type: 'Parent' },
  { name: 'Transition Type', key: 'transitionType', type: 'Parent' },
  {
    name: 'Service Type(s)',
    key: 'serviceTypeName',
    type: 'Parent',
    minTag: 2
  },
  { name: 'Allocated Employee Count', key: 'noOfEmployees', type: 'Parent' },
  {
    name: 'Property Type(s)',
    key: 'propertyType',
    type: 'Parent',
    minTag: 2,
    viewTagData: 'viewTagData'
  },
  {
    name: 'Property Sub Type(s)',
    key: 'propertySubType',
    type: 'Parent',
    minTag: 2,
    viewTagData: 'viewTagData'
  },
  {
    name: 'Property(s)',
    key: 'propertyName',
    type: 'Parent',
    minTag: 2,
    viewTagData: 'viewTagData',
    applyClassBasedOn: 'inactivePropertyName'
  },
  // {
  //   name: 'Multi Market Portfolio',
  //   key: 'isPortfolio',
  //   type: 'Parent',
  //   dataFormat: 'Boolean'
  // },
  { name: 'Client', key: 'clientName', type: 'Parent' },
  {
    name: 'Service(s) Start Date',
    key: 'ptfStartDate',
    type: 'Parent',
    dataFormat: 'Date'
  },
  { name: 'Service(s) End Date', key: 'ptfEndDate', type: 'Parent', dataFormat: 'Date' },
  { name: 'Status', key: 'approvalStatus', type: 'Parent' },
  {
    name: 'Action',
    key: 'marketId',
    type: 'Child',
    renderComponent: 'renderActionColumn',
    minWidth: 80
  }
  // { name: "TransitionId", key: "transitionId", type: "Parent" },
  // { name: "Transition On", key: "transitionOn", type: "Parent", format: "Date" },
];

export const clientColumns = [
  { name: 'Client Name', key: 'name', type: 'Parent' },
  { name: 'Address', key: 'address', type: 'Parent' },
  { name: 'City', key: 'city', type: 'Parent' },
  { name: 'State', key: 'state', type: 'Parent' },
  { name: 'Zip Code', key: 'zipCode', type: 'Parent' },
  { name: 'Phone Number', key: 'phoneNumber', type: 'Parent' },
  { name: 'Email', key: 'email', type: 'Parent' },
  // { name: 'Created By', key: 'createdBy', type: 'Parent' },
  // { name: 'Created Date', key: 'createdDate', type: 'Parent', dataFormat: 'Date' },

  // { name: 'Client Source', key: 'clientSource', type: 'Parent' },
  // { name: 'Modified By', key: 'modifiedBy', type: 'Parent' },
  // { name: 'Modified Date', key: 'modifiedDate', type: 'Parent', dataFormat: 'Date' },
  {
    name: 'Action',
    key: 'clientId',
    type: 'Child',
    renderComponent: 'renderActionColumn',
    minWidth: 80
  }
];

export const transitionListConfig = {
  collapsible: true,
  showEqualSpace: true,
  groupBy: 'parentId',
  groupOrderBy: 'transitionTypeId',
  appendText: { value: 'CIO', field: 'transitionType', where: { key: 'transitionTypeId', value: '1' } },
  inLineGroupBlock: true,
  orderBy: 'lastModifiedOn',
  order: 'desc',
  pagerGrouping: true
};
export const employeeColumns = [
  { name: 'Employee Name', key: 'preferredName', type: 'Parent' },
  { name: 'Email', key: 'email', type: 'Parent' },
  { name: 'Job Title', key: 'designation', type: 'Child' },
  { name: 'Base Location', key: 'allocationCityName', type: 'Child' },
  { name: 'Market', key: 'marketName', type: 'Child' },
  { name: 'Department', key: 'departmentName', type: 'Child' },
  { name: 'Allocated Property Type(s)', key: 'propertyTypeName', type: 'Child' },
  { name: 'Allocated Property(s)', key: 'propertyName', type: 'Child', minTag: 2, minWidth: 200, applyClassBasedOn: 'inactivePropertyName' },
  { name: 'Property Allocation Percent', key: 'allocationPercent', type: 'Child', applyColorBadge: true },
  { name: 'Property Billing Percent', key: 'billingPercent', type: 'Child', applyColorBadge: true },
  {
    name: 'Action',
    key: 'marketId',
    type: 'Child',
    renderComponent: 'renderActionColumn',
    minWidth: 80
  }
];

export const employeeConfig = {
  showPager: true,
  collapsible: false,
  inLineGroupBlock: false
};

export const allocationColumnsList = [
  {
    name: 'Market',
    key: 'marketName',
    type: 'Child',
    isRequired: true,
    isVisible: true,
    editSortOrder: 1,
    editConfig: {
      type: 'DropDown',
      sourceKey: 'marketMasterData',
      updateKey: 'marketId',
      sourceOption: 'marketName',
      title: 'Market Name',
      isEditField: true,
      isAddField: true
    }
  },
  {
    name: 'Employee Name',
    key: 'preferredName',
    keyTag: 'property',
    type: 'Parent',
    fieldId: 'employeeId',
    isRequired: true,
    isVisible: true,
    editSortOrder: 2,
    editConfig: {
      type: 'DropDown',
      sourceKey: 'employeeMasterData',
      updateKey: 'employeeId',
      sourceOption: 'employeeName',
      title: 'Employee Name',
      isEditField: false,
      isAddField: true
    },
    hideWhen: [{ key: "allocationType", value: "Property" }],
    allocationType: 'Market'
  },
  {
    name: 'Employee Name',
    key: 'preferredName',
    type: 'Parent',
    fieldId: 'employeeId',
    isRequired: true,
    isVisible: true,
    editSortOrder: 2,
    editConfig: {
      type: 'DropDown',
      sourceKey: 'employeeMasterData',
      updateKey: 'employeeId',
      sourceOption: 'employeeName',
      title: 'Employee Name',
      isEditField: false,
      isAddField: true
    },
    hideWhen: [{ key: "allocationType", value: "Market" }],
    dependentFieldValidation: ['pmaTitle'],
    // filterSourceOn: [
    //   { key: 'marketId', filterBy: 'marketId', ignoreWhen: { key: 'serviceTypeId', value: 3 } }
    // ],
    filterMultipleSourceOn: [
      { key: 'marketId', filterSingleKey: 'marketId', filterBy: 'otherMarketId', ignoreWhen: { key: 'serviceTypeId', value: 3 } }
    ],
    allocationType: 'Property'
  },
  {
    name: 'Department',
    key: 'departmentName',
    keyTag: 'departmentName',
    type: 'Parent',
    fieldId: 'departmentId',
    isRequired: true,
    isVisible: true,
    editSortOrder: 3,
    editConfig: {
      type: 'DropDown',
      sourceKey: 'departmentFilteredMasterData',
      updateKey: 'departmentId',
      sourceOption: 'departmentName',
      title: 'Department',
      isEditField: true,
      isAddField: true
    },
    hideWhen: [{ key: "allocationType", value: "Property" }]
  },
  {
    name: "Department",
    key: "departmentName",
    editSortOrder: 3,
    hideWhen: [{ key: "allocationType", value: "Market" }]
  },
  {
    name: 'PMA Title',
    key: 'pmaTitle',
    type: 'Child',
    isRequired: true,
    isVisible: true,
    editSortOrder: 4,
    size: 12,
    width: '33%',
    editConfig: {
      type: 'DropDown',
      sourceKey: 'pmaTitleMasterData',
      updateKey: 'pmaTitleId',
      sourceOption: 'pmaTitle',
      title: 'PMA Title',
      isAddField: true,
      showWhen: [{ key: 'marketId', value: 6 }, { key: 'marketId', value: 7 }]
    },
    hideWhen: [{ key: "allocationType", value: "Market" }]
  },
  {
    name: 'Division',
    key: 'division',
    keyTag: 'division',
    type: 'Parent',
    fieldId: 'divisionId',
    isRequired: true,
    isVisible: true,
    editSortOrder: 4,
    editConfig: {
      type: 'DropDown',
      sourceKey: 'divisionMasterData',
      updateKey: 'divisionId',
      sourceOption: 'division',
      title: 'Division',
      isEditField: true,
      isAddField: true
    },
    hideWhen: [{ key: "allocationType", value: "Property" }],
    allocationType: 'Market'
  },
  {
    name: "Legal Entity Allocation",
    key: "isAllocatedToLegalEntity",
    editSortOrder: 10,
    editConfig: {
      type: "Switch",
      isEditField: true,
      isAddField: true,
      toolTip: 'Use for Portfolio'
    },
    hideWhen: [{ key: "allocationType", value: "Market" }]
  },
  {
    name: "Property Name",
    key: "propertyName",
    type: "Child",
    fieldId: 'propertyId',
    isVisible: true,
    editSortOrder: 11,
    editConfig: {
      type: 'DropDown',
      sourceKey: 'propertyMasterData',
      updateKey: 'propertyId',
      sourceOption: 'propertyName',
      title: 'Property Name',
      isEditField: true,
      isAddField: true,
      hideWhen: [{ key: "isAllocatedToLegalEntity", value: true }]
    },
    dependentValidation: { key: "isAllocatedToLegalEntity", value: false },
    filterSourceOn: [
      { key: 'marketId', filterBy: 'marketId' }
    ],
    hideWhen: [{ key: "allocationType", value: "Market" }],
    notEditWhen: { key: "allocationType", value: "Market" }
  },
  {
    name: "Legal Entity",
    key: "legalEntity",
    type: "Child",
    fieldId: 'legalEntityId',
    isVisible: true,
    editSortOrder: 11,
    editConfig: {
      type: "DropDown",
      sourceKey: "propertyMasterData",
      updateKey: "legalEntityId",
      sourceOption: "legalEntity",
      title: "Legal Entity Name",
      isEditField: true,
      distinctOn: "legalEntity",
      isAddField: true,
      hideWhen: [{ key: "isAllocatedToLegalEntity", value: false }]
    },
    filterSourceOn: [
      { key: 'marketId', filterBy: 'marketId' }
    ],
    dependentValidation: { key: "isAllocatedToLegalEntity", value: true },
    hideWhen: [{ key: "allocationType", value: "Market" }],
    notEditWhen: { key: "allocationType", value: "Market" }
  },
  {
    name: "Property Type",
    key: "propertyTypeName",
    type: "Child",
    editSortOrder: 12,
    hideWhen: [{ key: "allocationType", value: "Market" }]
  },
  {
    name: 'Allocation Start Date',
    key: 'allocationStartDate',
    keyTag: 'property',
    type: 'Child',
    isRequired: true,
    isVisible: true,
    editSortOrder: 5,
    dataFormat: 'Date',
    editConfig: {
      type: 'DatePicker',
      isEditField: true,
      isAddField: true
      // shouldDisableDate: disableDatesForPayCycleStart1

    },
    rules: {
      And: [
        {
          operator: Operators.LessThanEqualsTo,
          key: 'allocationEndDate',
          displayName: 'Allocation End Date'
        }
      ]
    },
    dependentFieldValidation: ['allocationEndDate'],
    hideWhen: [{ key: "allocationType", value: "Property" }],
    allocationType: 'Market'
  },
  {
    name: 'Allocation End Date',
    key: 'allocationEndDate',
    keyTag: 'property',
    type: 'Child',
    dataFormat: 'Date',
    editSortOrder: 6,
    editConfig: {
      type: 'DatePicker',
      isEditField: true,
      isAddField: true
      // shouldDisableDate: disableDatesForPayCycleEnd1
    },
    rules: {
      And: [
        {
          operator: Operators.GreaterThanEqualsTo,
          key: 'allocationStartDate',
          displayName: 'Allocation Start Date'
        }
      ]
    },
    dependentFieldValidation: ['allocationStartDate'],
    hideWhen: [{ key: "allocationType", value: "Property" }],
    allocationType: 'Market'
  },
  {
    name: 'Allocation Start Date',
    key: 'allocationStartDate',
    type: 'Child',
    dataFormat: 'Date',
    isRequired: true,
    isVisible: true,
    editSortOrder: 5,
    editConfig: {
      type: 'DatePicker',
      isEditField: true,
      isAddField: true
      // shouldDisableDate: disableDatesForPayCycleStart1

    },
    rules: {
      And: [
        {
          operator: Operators.LessThanEqualsTo,
          key: 'allocationEndDate',
          displayName: 'Allocation End Date'
        },
        {
          operator: Operators.LessThanEqualsTo,
          key: 'billingStartDate',
          displayName: 'Billing Start Date'
        }
      ]
    },
    dependentFieldValidation: ['allocationEndDate', 'billingStartDate'],
    hideWhen: [{ key: "allocationType", value: "Market" }],
    allocationType: 'Property'
  },
  {
    name: 'Allocation End Date',
    key: 'allocationEndDate',
    type: 'Child',
    editSortOrder: 6,
    dataFormat: 'Date',
    editConfig: {
      type: 'DatePicker',
      isEditField: true,
      isAddField: true
      // shouldDisableDate: disableDatesForPayCycleEnd1
    },
    rules: {
      And: [
        {
          operator: Operators.GreaterThanEqualsTo,
          key: 'allocationStartDate',
          displayName: 'Allocation Start Date'
        },
        {
          operator: Operators.GreaterThanEqualsTo,
          key: 'billingStartDate',
          displayName: 'Billing Start Date'
        },
        {
          operator: Operators.GreaterThanEqualsTo,
          key: 'billingEndDate',
          displayName: 'Billing End Date'
        }
      ]
    },
    dependentFieldValidation: ['allocationStartDate', 'billingStartDate', 'billingEndDate'],
    hideWhen: [{ key: "allocationType", value: "Market" }],
    allocationType: 'Property'
  },
  {
    name: "Property Allocation Percent",
    key: "propertyAllocationPercent",
    type: "Child",
    editSortOrder: 7,
    isRequired: true,
    isVisible: true,
    hideWhen: [{ key: "allocationType", value: "Market" }],
    editConfig: {
      type: 'TextNumber',
      isEditField: true,
      isAddField: true,
      isAvoidFormatting: true
    },
    notEditWhen: { key: 'allocationType', value: 'Market' },
    rules: {
      And: [
        {
          operator: Operators.GreaterThan,
          key: '',
          // displayName: 'Property Billing Percent'
          value: 0
        },
        {
          operator: Operators.GreaterThanEqualsTo,
          key: 'propertyBillingPercent',
          displayName: 'Property Billing Percent'
        }
      ]
    },
    dependentFieldValidation: ['propertyBillingPercent']
  },
  {
    name: "Market Allocation Percent",
    key: "marketAllocationPercent",
    type: "Child",
    isRequired: true,
    isVisible: true,
    editSortOrder: 7,
    hideWhen: [{
      key: "allocationType",
      value: "Property"
    }],
    editConfig: {
      type: 'TextNumber',
      isEditField: true,
      isAddField: true,
      isAvoidFormatting: true
    },
    rules: {
      And: [
        {
          operator: Operators.GreaterThan,
          key: '',
          // displayName: 'Property Billing Percent'
          value: 0
        }
      ]
    }
  },
  {
    name: 'Billing Start Date',
    key: 'billingStartDate',
    type: 'Child',
    dataFormat: 'Date',
    isRequired: true,
    isVisible: true,
    editSortOrder: 8,
    editConfig: {
      type: 'DatePicker',
      isEditField: true,
      isAddField: true
      // shouldDisableDate: disableDatesForPayCycleStart1
    },
    rules: {
      And: [
        {
          operator: Operators.LessThanEqualsTo,
          key: 'billingEndDate',
          displayName: 'Billing End Date'
        },
        {
          operator: Operators.LessThanEqualsTo,
          key: 'allocationEndDate',
          displayName: 'Allocation End Date'
        },
        {
          operator: Operators.GreaterThanEqualsTo,
          key: 'allocationStartDate',
          displayName: 'Allocation Start Date'
        }
      ]
    },
    hideWhen: [{ key: "allocationType", value: "Market" }],
    notEditWhen: { key: "allocationType", value: "Market" },
    dependentFieldValidation: ['allocationStartDate', 'billingEndDate', 'allocationEndDate']
  },
  {
    name: 'Billing End Date',
    key: 'billingEndDate',
    type: 'Child',
    dataFormat: 'Date',
    showInEditOnly: true,
    editSortOrder: 9,
    editConfig: {
      type: 'DatePicker',
      isEditField: true,
      isAddField: true
      // shouldDisableDate: disableDatesForPayCycleEnd1
    },
    rules: {
      And: [
        {
          operator: Operators.GreaterThanEqualsTo,
          key: 'billingStartDate',
          displayName: 'Billing Start Date'
        },
        {
          operator: Operators.LessThanEqualsTo,
          key: 'allocationEndDate',
          displayName: 'Allocation End Date'
        }
      ]
    },
    hideWhen: [{ key: "allocationType", value: "Market" }],
    notEditWhen: { key: "allocationType", value: "Market" },
    dependentFieldValidation: ['billingStartDate', 'allocationEndDate']
  },

  {
    name: 'Is Reimbursed',
    key: 'isReimbursed',
    editSortOrder: 13,
    editConfig: {
      type: 'Switch',
      isEditField: true,
      isAddField: true
    },
    hideWhen: [{ key: "allocationType", value: "Market" }]
  },
  {
    name: "Property Billing Percent",
    key: "propertyBillingPercent",
    type: "Child",
    isRequired: true,
    isVisible: true,
    editSortOrder: 14,
    hideWhen: [{ key: "allocationType", value: "Market" }],
    editConfig: {
      type: 'TextNumber',
      isEditField: true,
      isAddField: true,
      isAvoidFormatting: true,
      hideWhen: [{ key: "isReimbursed", value: false }]
    },
    dependentValidation: { key: "isReimbursed", value: true },
    rules: {
      And: [
        {
          operator: Operators.GreaterThanEqualsTo,
          key: '',
          value: 0
        },
        {
          operator: Operators.LessThanEqualsTo,
          key: 'propertyAllocationPercent',
          displayName: 'Property Allocation Percent'
        }
      ]
    },
    dependentFieldValidation: ['propertyAllocationPercent']
  },
  // {
  //   name: "Market Billing Percent",
  //   key: "marketBillingPercent",
  //   type: "Child",
  //   isRequired: true,
  //   isVisible: true,
  //   editSortOrder: 15,
  //   hideWhen: [{ key: "allocationType", value: "Property" }],
  //   editConfig: {
  //     type: 'TextField',
  //     isEditField: true,
  //     isAddField: true,
  //     hideWhen: [{ key: "isReimbursed", value: false }]
  //   },
  //   dependentValidation: { key: "isReimbursed", value: true },
  //   rules: {
  //     And: [
  //       {
  //         operator: Operators.LessThanEqualsTo,
  //         key: 'marketAllocationPercent',
  //         displayName: 'Market Allocation Percent'
  //       }
  //     ]
  //   },
  //   hideWhen: [{ key: "allocationType", value: "Market" }]
  // },

  {
    name: 'Flat Fee Amount',
    key: 'additionalFixedAmount',
    type: 'Child',
    displayFormat: 'MoneyDecimal',
    decimalPrecision: 2,
    isVisible: true,
    editSortOrder: 16,
    editConfig: {
      type: 'TextNumber',
      isEditField: true,
      isAddField: true,
      hideWhen: [{ key: "isReimbursed", value: false }],
      isAvoidFormatting: true
    },
    notEditWhen: { key: "isReimbursed", value: false },
    hideWhen: [{ key: "allocationType", value: "Market" }],
    dependentValidation: { key: "isReimbursed", value: true },
    rules: {
      And: [
        {
          operator: Operators.GreaterThanEqualsTo,
          key: '',
          value: 0
        }
      ]
    }
  },
  {
    name: 'Total Approved Employee Property Allocation %', // "Current Overall Property Allocation",
    key: "overallPropertyAllocationPercent",
    type: "Child",
    editSortOrder: 20,
    hideWhen: [{ key: "allocationType", value: "Market" }],
    applyColorBadge: true
  },
  {
    name: "Total Approved Employee Market Allocation %", // "Current Overall Market Allocation",
    key: "overallMarketAllocationPercent",
    type: "Child",
    editSortOrder: 21,
    hideWhen: [{ key: "allocationType", value: "Property" }],
    applyColorBadge: true
  },
  {
    name: 'Total Approved Employee Property Billing %', // "Current Overall Property Billing",
    key: "overallPropertyBillingPercent",
    type: "Child",
    editSortOrder: 19,
    hideWhen: [{ key: "allocationType", value: "Market" }],
    applyColorBadge: true,
    editConfig: {
      hideWhen: [{ key: "isReimbursed", value: false }]
    }
  },
  {
    name: "Review Comment",
    key: "reviewComment",
    type: "Child",
    editSortOrder: 25,
    showInEditOnly: true
  },
  // {
  //   name: "Overall Market Billing",
  //   key: "overallMarketBillingPercent",
  //   type: "Child",
  //   editSortOrder: 19,
  //   hideWhen: [{ key: "allocationType", value: "Property" }],
  //   applyColorBadge: true
  // },
  {
    name: "Burden Rate",
    key: "burdenRate",
    editSortOrder: 22,
    hideWhen: [{ key: "allocationType", value: "Market" }],
    notEditWhen: { key: "allocationType", value: "Market" }
  },
  {
    name: "Account Code Name",
    key: "category",
    editSortOrder: 23,
    hideWhen: [{ key: "allocationType", value: "Market" }],
    notEditWhen: { key: "allocationType", value: "Market" }
  },
  {
    name: "Status",
    key: "approvalStatus",
    type: "Child",
    editSortOrder: 24,
    dynamicRenderForm: 'legalEntityAndPropertyData'
  },
  {
    name: 'Created By',
    key: 'createdBy',
    type: 'Child',
    editSortOrder: 25,
    showInEditOnly: true
  },
  {
    name: 'Created On',
    key: 'createdOn',
    type: 'Child',
    dataFormat: 'Date',
    editSortOrder: 26,
    showInEditOnly: true
  },
  {
    name: 'Modified By',
    key: 'lastModifiedBy',
    type: 'Child',
    editSortOrder: 27,
    showInEditOnly: true
  },
  {
    name: 'Modified On',
    key: 'lastModifiedOn',
    type: 'Child',
    dataFormat: 'Date',
    editSortOrder: 28,
    showInEditOnly: true
  },
  {
    name: 'Approved By',
    key: 'approvedBy',
    type: 'Child',
    editSortOrder: 29,
    showInEditOnly: true
  },
  {
    name: 'Approved On',
    key: 'approvedOn',
    type: 'Child',
    dataFormat: 'Date',
    editSortOrder: 30,
    showInEditOnly: true
  },
  {
    name: 'Action',
    key: 'marketId',
    type: 'Child',
    editSortOrder: 301,
    renderComponent: 'renderActionColumn',
    minWidth: 90
  }
];

export const overTimeColumnList = [
  {
    name: 'Market',
    key: 'marketName',
    type: 'Child',
    isRequired: true,
    isVisible: true,
    editSortOrder: 1,
    editConfig: {
      type: 'DropDown',
      sourceKey: 'marketMasterData',
      updateKey: 'marketId',
      sourceOption: 'marketName',
      title: 'Market Name',
      isEditField: true,
      isAddField: true
    },
    hideWhen: [{ key: "allocationType", value: "Property" }]
  },
  {
    name: 'Employee Name',
    key: 'preferredName',
    keyTag: 'property',
    type: 'Parent',
    fieldId: 'employeeId',
    isRequired: true,
    isVisible: true,
    editSortOrder: 2,
    editConfig: {
      type: 'DropDown',
      sourceKey: 'employeeMasterData',
      updateKey: 'employeeId',
      sourceOption: 'employeeName',
      title: 'Employee Name',
      isEditField: false,
      isAddField: true
    },
    hideWhen: [{ key: "allocationType", value: "Property" }],
    allocationType: 'Market'
  },
  {
    name: 'Employee Name',
    key: 'preferredName',
    type: 'Parent',
    fieldId: 'employeeId',
    isRequired: true,
    isVisible: true,
    editSortOrder: 2,
    editConfig: {
      type: 'DropDown',
      sourceKey: 'employeeMasterData',
      updateKey: 'employeeId',
      sourceOption: 'employeeName',
      title: 'Employee Name',
      isEditField: false,
      isAddField: true
    },
    hideWhen: [{ key: "allocationType", value: "Market" }],
    filterSourceOn: [
      { key: 'marketId', filterBy: 'marketId', ignoreWhen: { key: 'serviceTypeId', value: 3 } }
    ],
    allocationType: 'Property'
  },
  // {
  //   name: "Department",
  //   key: "departmentName",
  //   editSortOrder: 3
  // },
  // {
  //   name: "Legal Entity Allocation",
  //   key: "isAllocatedToLegalEntity",
  //   editSortOrder: 9,
  //   editConfig: {
  //     type: "Switch",
  //     isEditField: true,
  //     isAddField: true,
  //     toolTip: 'Use for Portfolio'
  //   },
  //   hideWhen: [{ key: "allocationType", value: "Market" }]
  // },
  // {
  //   name: "Property Name",
  //   key: "propertyName",
  //   type: "Child",
  //   fieldId: 'propertyId',
  //   isVisible: true,
  //   editSortOrder: 10,
  //   editConfig: {
  //     type: 'DropDown',
  //     sourceKey: 'propertyMasterData',
  //     updateKey: 'propertyId',
  //     sourceOption: 'propertyName',
  //     title: 'Property Name',
  //     isEditField: true,
  //     isAddField: true,
  //     hideWhen: [{ key: "isAllocatedToLegalEntity", value: true }],
  //   },
  //   dependentValidation: { key: "isAllocatedToLegalEntity", value: false },
  //   filterSourceOn: [
  //     { key: 'marketId', filterBy: 'marketId' }
  //   ],
  //   hideWhen: [{ key: "allocationType", value: "Market" }],
  //   notEditWhen: { key: "allocationType", value: "Market" }
  // },
  // {
  //   name: "Legal Entity",
  //   key: "legalEntity",
  //   type: "Child",
  //   fieldId: 'legalEntityId',
  //   isVisible: true,
  //   editSortOrder: 11,
  //   editConfig: {
  //     type: "DropDown",
  //     sourceKey: "propertyMasterData",
  //     updateKey: "legalEntityId",
  //     sourceOption: "legalEntity",
  //     title: "Legal Entity Name",
  //     isEditField: true,
  //     distinctOn: "legalEntity",
  //     isAddField: true,
  //     hideWhen: [{ key: "isAllocatedToLegalEntity", value: false }]
  //   },
  //   filterSourceOn: [
  //     { key: 'marketId', filterBy: 'marketId' }
  //   ],
  //   dependentValidation: { key: "isAllocatedToLegalEntity", value: true },
  //   hideWhen: [{ key: "allocationType", value: "Market" }],
  //   notEditWhen: { key: "allocationType", value: "Market" }
  // },
  {
    name: "Property Type",
    key: "propertyTypeName",
    type: "Child",
    editSortOrder: 12,
    hideWhen: [{ key: "allocationType", value: "Market" }]
  },
  {
    name: 'Allocation Start Date',
    key: 'allocationStartDate',
    keyTag: 'property',
    type: 'Child',
    isRequired: true,
    isVisible: true,
    editSortOrder: 4,
    dataFormat: 'Date',
    editConfig: {
      type: 'DatePicker',
      isEditField: true,
      isAddField: true
      // shouldDisableDate: disableDatesForPayCycleStart1

    },
    rules: {
      And: [
        {
          operator: Operators.LessThanEqualsTo,
          key: 'allocationEndDate',
          displayName: 'Allocation End Date'
        }
      ]
    },
    dependentFieldValidation: ['allocationEndDate'],
    hideWhen: [{ key: "allocationType", value: "Property" }],
    allocationType: 'Market'
  },
  {
    name: 'Allocation End Date',
    key: 'allocationEndDate',
    keyTag: 'property',
    type: 'Child',
    dataFormat: 'Date',
    editSortOrder: 5,
    editConfig: {
      type: 'DatePicker',
      isEditField: true,
      isAddField: true
      // shouldDisableDate: disableDatesForPayCycleEnd1
    },
    rules: {
      And: [
        {
          operator: Operators.GreaterThanEqualsTo,
          key: 'allocationStartDate',
          displayName: 'Allocation Start Date'
        }
      ]
    },
    dependentFieldValidation: ['allocationStartDate'],
    hideWhen: [{ key: "allocationType", value: "Property" }],
    allocationType: 'Market'
  },
  {
    name: 'Allocation Start Date',
    key: 'allocationStartDate',
    type: 'Child',
    dataFormat: 'Date',
    isRequired: true,
    isVisible: true,
    editSortOrder: 4,
    editConfig: {
      type: 'DatePicker',
      isEditField: true,
      isAddField: true
      // shouldDisableDate: disableDatesForPayCycleStart1

    },
    rules: {
      And: [
        {
          operator: Operators.LessThanEqualsTo,
          key: 'allocationEndDate',
          displayName: 'Allocation End Date'
        },
        {
          operator: Operators.LessThanEqualsTo,
          key: 'billingStartDate',
          displayName: 'Billing Start Date'
        }
      ]
    },
    dependentFieldValidation: ['allocationEndDate', 'billingStartDate'],
    hideWhen: [{ key: "allocationType", value: "Market" }],
    allocationType: 'Property'
  },
  {
    name: 'Allocation End Date',
    key: 'allocationEndDate',
    type: 'Child',
    editSortOrder: 5,
    dataFormat: 'Date',
    editConfig: {
      type: 'DatePicker',
      isEditField: true,
      isAddField: true
      // shouldDisableDate: disableDatesForPayCycleEnd1
    },
    rules: {
      And: [
        {
          operator: Operators.GreaterThanEqualsTo,
          key: 'allocationStartDate',
          displayName: 'Allocation Start Date'
        },
        {
          operator: Operators.GreaterThanEqualsTo,
          key: 'billingStartDate',
          displayName: 'Billing Start Date'
        },
        {
          operator: Operators.GreaterThanEqualsTo,
          key: 'billingEndDate',
          displayName: 'Billing End Date'
        }
      ]
    },
    dependentFieldValidation: ['allocationStartDate', 'billingStartDate', 'billingEndDate'],
    hideWhen: [{ key: "allocationType", value: "Market" }],
    allocationType: 'Property'
  },
  {
    name: "Property Allocation Percent",
    key: "propertyAllocationPercent",
    type: "Child",
    editSortOrder: 6,
    isRequired: true,
    isVisible: true,
    hideWhen: [{ key: "allocationType", value: "Market" }],
    editConfig: {
      type: 'TextField',
      isEditField: true,
      isAddField: true,
      isAvoidFormatting: true
    },
    notEditWhen: { key: 'allocationType', value: 'Market' },
    rules: {
      And: [
        {
          operator: Operators.GreaterThanEqualsTo,
          key: 'propertyBillingPercent',
          displayName: 'Property Billing Percent'
        },
        {
          operator: Operators.GreaterThanEqualsTo,
          key: '',
          // displayName: 'Property Billing Percent'
          value: 0
        }
      ]
    },
    dependentFieldValidation: ['propertyBillingPercent']
  },
  {
    name: "Market Allocation Percent",
    key: "marketAllocationPercent",
    type: "Child",
    isRequired: true,
    isVisible: true,
    editSortOrder: 6,
    hideWhen: [{
      key: "allocationType",
      value: "Property"
    }],
    editConfig: {
      type: 'TextField',
      isEditField: true,
      isAddField: true
    },
    rules: {
      And: [
        {
          operator: Operators.GreaterThanEqualsTo,
          key: '',
          // displayName: 'Property Billing Percent'
          value: 0
        }
      ]
    }
  },
  {
    name: 'Billing Start Date',
    key: 'billingStartDate',
    type: 'Child',
    dataFormat: 'Date',
    isRequired: true,
    isVisible: true,
    editSortOrder: 7,
    editConfig: {
      type: 'DatePicker',
      isEditField: true,
      isAddField: true
      // shouldDisableDate: disableDatesForPayCycleStart1
    },
    rules: {
      And: [
        {
          operator: Operators.LessThanEqualsTo,
          key: 'billingEndDate',
          displayName: 'Billing End Date'
        },
        {
          operator: Operators.LessThanEqualsTo,
          key: 'allocationEndDate',
          displayName: 'Allocation End Date'
        },
        {
          operator: Operators.GreaterThanEqualsTo,
          key: 'allocationStartDate',
          displayName: 'Allocation Start Date'
        }
      ]
    },
    hideWhen: [{ key: "allocationType", value: "Market" }],
    notEditWhen: { key: "allocationType", value: "Market" },
    dependentFieldValidation: ['allocationStartDate', 'billingEndDate', 'allocationEndDate']
  },
  {
    name: 'Billing End Date',
    key: 'billingEndDate',
    type: 'Child',
    dataFormat: 'Date',
    showInEditOnly: true,
    editSortOrder: 8,
    editConfig: {
      type: 'DatePicker',
      isEditField: true,
      isAddField: true
      // shouldDisableDate: disableDatesForPayCycleEnd1
    },
    rules: {
      And: [
        {
          operator: Operators.GreaterThanEqualsTo,
          key: 'billingStartDate',
          displayName: 'Billing Start Date'
        },
        {
          operator: Operators.LessThanEqualsTo,
          key: 'allocationEndDate',
          displayName: 'Allocation End Date'
        }
      ]
    },
    hideWhen: [{ key: "allocationType", value: "Market" }],
    notEditWhen: { key: "allocationType", value: "Market" },
    dependentFieldValidation: ['billingStartDate', 'allocationEndDate']
  },

  {
    name: 'Is Reimbursed',
    key: 'isReimbursed',
    editSortOrder: 13,
    editConfig: {
      type: 'Switch',
      isEditField: true,
      isAddField: true
    },
    hideWhen: [{ key: "allocationType", value: "Market" }]
  },
  {
    name: "Property Billing Percent",
    key: "propertyBillingPercent",
    type: "Child",
    isRequired: true,
    isVisible: true,
    editSortOrder: 14,
    hideWhen: [{ key: "allocationType", value: "Market" }],
    editConfig: {
      type: 'TextField',
      isEditField: true,
      isAddField: true,
      isAvoidFormatting: true,
      hideWhen: [{ key: "isReimbursed", value: false }]
    },
    dependentValidation: { key: "isReimbursed", value: true },
    rules: {
      And: [
        {
          operator: Operators.LessThanEqualsTo,
          key: 'propertyAllocationPercent',
          displayName: 'Property Allocation Percent'
        }
      ]
    },
    dependentFieldValidation: ['propertyAllocationPercent']
  },
  {
    name: 'Flat Fee Amount',
    key: 'additionalFixedAmount',
    type: 'Child',
    displayFormat: 'MoneyDecimal',
    isVisible: true,
    editSortOrder: 16,
    editConfig: {
      type: 'TextField',
      isEditField: true,
      isAddField: true,
      hideWhen: [{ key: "isReimbursed", value: false }]
    },
    notEditWhen: { key: "isReimbursed", value: false },
    hideWhen: [{ key: "allocationType", value: "Market" }],
    dependentValidation: { key: "isReimbursed", value: true }
  },
  {
    name: "Comments", // "Current Overall Market Allocation",
    key: "overallMarketAllocationPercent",
    type: "Child",
    editSortOrder: 21,
    hideWhen: [{ key: "allocationType", value: "Property" }],
    applyColorBadge: true
  },
  {
    name: 'Total Approved Employee Property Billing %', // "Current Overall Property Billing",
    key: "overallPropertyBillingPercent",
    type: "Child",
    editSortOrder: 19,
    hideWhen: [{ key: "allocationType", value: "Market" }],
    applyColorBadge: true,
    editConfig: {
      hideWhen: [{ key: "isReimbursed", value: false }]
    }
  },
  {
    name: "Review Comment",
    key: "reviewComment",
    type: "Child",
    editSortOrder: 25,
    showInEditOnly: true
  },
  {
    name: "Status",
    key: "approvalStatus",
    type: "Child"

  },

  {
    name: 'Action',
    key: 'marketId',
    type: 'Child',
    editSortOrder: 301,
    renderComponent: 'renderActionColumn',
    minWidth: 90
  }
];

export const propertyAllocationList = [

  {
    name: 'Market',
    key: 'marketName',
    type: 'Child',
    isRequired: true,
    isVisible: true,
    editSortOrder: 1,
    editConfig: {
      type: 'DropDown',
      sourceKey: 'marketMasterData',
      updateKey: 'marketId',
      sourceOption: 'marketName',
      title: 'Market Name',
      isEditField: true,
      isAddField: true
    }
  },
  {
    name: 'Employee Name',
    key: 'preferredName',
    type: 'Parent',
    fieldId: 'employeeId',
    isVisible: true,
    isRequired: true,
    editSortOrder: 2,
    editConfig: {
      type: 'DropDown',
      sourceKey: 'employeeMasterData',
      updateKey: 'employeeId',
      sourceOption: 'employeeName',
      title: 'Employee Name',
      isEditField: false,
      isAddField: true,
      distinctOn: "employeeId"
    },
    dependentFieldValidation: ['pmaTitle'],
    // filterSourceOn: [
    //   { key: 'marketId', filterBy: 'marketId', ignoreWhen: { key: 'serviceTypeId', value: 3 } }
    // ]
    filterMultipleSourceOn: [
      { key: 'marketId', filterSingleKey: 'marketId', filterBy: 'otherMarketId', ignoreWhen: { key: 'serviceTypeId', value: 3 } }
    ]
  },
  {
    name: "Department",
    key: "departmentName",
    editSortOrder: 3
  },
  {
    name: 'PMA Title',
    key: 'pmaTitle',
    type: 'Child',
    isRequired: true,
    editSortOrder: 4,
    isVisible: true,
    size: 12,
    width: '33%',
    editConfig: {
      type: 'DropDown',
      sourceKey: 'pmaTitleMasterData',
      updateKey: 'pmaTitleId',
      sourceOption: 'pmaTitle',
      title: 'PMA Title',
      isAddField: true,
      showWhen: [{ key: 'marketId', value: 6 }, { key: 'marketId', value: 7 }]
    },
    hideWhen: [{ key: "allocationType", value: "Market" }]
  },
  {
    name: "Is Allocated to Legal Entity",
    key: "isAllocatedToLegalEntity",
    editSortOrder: 10,
    editConfig: {
      type: "Switch",
      isEditField: true,
      isAddField: true,
      toolTip: 'Use for Portfolio'
    },
    hideWhen: [{ key: "allocationType", value: "Market" }]
  },
  {
    name: "Property Name",
    key: "propertyName",
    type: "Child",
    fieldId: 'propertyId',
    isVisible: true,
    editSortOrder: 11,
    editConfig: {
      type: 'DropDown',
      sourceKey: 'propertyMasterData',
      updateKey: 'propertyId',
      sourceOption: 'propertyName',
      title: 'Property Name',
      isEditField: true,
      isAddField: true,
      distinctOn: "propertyId",
      hideWhen: [{ key: "isAllocatedToLegalEntity", value: true }]
    },
    dependentValidation: { key: "isAllocatedToLegalEntity", value: false },
    // filterSourceOn: [
    //   { key: 'marketId', filterBy: 'marketId' }
    // ],
    hideWhen: [{ key: "allocationType", value: "Market" }],
    notEditWhen: { key: "allocationType", value: "Market" }
  },
  {
    name: "Legal Entity",
    key: "legalEntity",
    type: "Child",
    fieldId: 'legalEntityId',
    isVisible: true,
    editSortOrder: 11,
    editConfig: {
      type: "DropDown",
      sourceKey: "propertyMasterData",
      updateKey: "legalEntityId",
      sourceOption: "legalEntity",
      title: "Legal Entity Name",
      isEditField: true,
      isAddField: true,
      distinctOn: "legalEntity",
      hideWhen: [{ key: "isAllocatedToLegalEntity", value: false }]
    },
    // filterSourceOn: [
    //   { key: 'marketId', filterBy: 'marketId' }
    // ],
    dependentValidation: { key: "isAllocatedToLegalEntity", value: true },
    hideWhen: [{ key: "allocationType", value: "Market" }],
    notEditWhen: { key: "allocationType", value: "Market" }
  },

  {
    name: 'Property Type',
    key: 'propertyTypeName',
    editSortOrder: 12,
    type: 'Child'
  },

  {
    name: 'Allocation Start Date',
    key: 'allocationStartDate',
    isRequired: true,
    isVisible: true,
    editSortOrder: 5,
    type: 'Child',
    dataFormat: 'Date',
    editConfig: {
      type: 'DatePicker',
      isEditField: true,
      isAddField: true
      // shouldDisableDate: disableDatesForPayCycleStart1
    },
    rules: {
      And: [
        {
          operator: Operators.LessThanEqualsTo,
          key: 'allocationEndDate',
          displayName: 'Allocation End Date'
        }
      ]
    },
    dependentFieldValidation: ['allocationEndDate']
  },
  {
    name: 'Allocation End date',
    key: 'allocationEndDate',
    editSortOrder: 6,
    type: 'Child',
    dataFormat: 'Date',
    editConfig: {
      type: 'DatePicker',
      isEditField: true,
      isAddField: true
      // shouldDisableDate: disableDatesForPayCycleEnd1

    },
    rules: {
      And: [
        {
          operator: Operators.GreaterThanEqualsTo,
          key: 'allocationStartDate',
          displayName: 'Allocation Start Date'
        },
        {
          operator: Operators.GreaterThanEqualsTo,
          key: 'billingStartDate',
          displayName: 'Billing Start Date'
        },
        {
          operator: Operators.GreaterThanEqualsTo,
          key: 'billingEndDate',
          displayName: 'Billing End Date'
        }
      ]
    },
    dependentFieldValidation: ['allocationStartDate', 'billingStartDate', 'billingEndDate']
  },
  {
    name: 'Billing Start Date',
    key: 'billingStartDate',
    type: 'Child',
    isRequired: true,
    isVisible: true,
    editSortOrder: 8,
    dataFormat: 'Date',
    editConfig: {
      type: 'DatePicker',
      isEditField: true,
      isAddField: true
      // shouldDisableDate: disableDatesForPayCycleStart1
    },
    rules: {
      And: [
        {
          operator: Operators.LessThanEqualsTo,
          key: 'billingEndDate',
          displayName: 'Billing End Date'
        },
        {
          operator: Operators.LessThanEqualsTo,
          key: 'allocationEndDate',
          displayName: 'Allocation End Date'
        },
        {
          operator: Operators.GreaterThanEqualsTo,
          key: 'allocationStartDate',
          displayName: 'Allocation Start Date'
        }
      ]
    },
    dependentFieldValidation: ['allocationStartDate', 'billingEndDate', 'allocationEndDate']
  },
  {
    name: 'Billing End Date',
    key: 'billingEndDate',
    type: 'Child',
    isVisible: true,
    editSortOrder: 9,
    dataFormat: 'Date',
    editConfig: {
      type: 'DatePicker',
      isEditField: true,
      isAddField: true
      // shouldDisableDate: disableDatesForPayCycleEnd1
    },
    rules: {
      And: [
        {
          operator: Operators.GreaterThanEqualsTo,
          key: 'billingStartDate',
          displayName: 'Billing Start Date'
        },
        {
          operator: Operators.LessThanEqualsTo,
          key: 'allocationEndDate',
          displayName: 'Allocation End Date'
        }
      ]
    },
    dependentFieldValidation: ['billingStartDate', 'allocationEndDate']
  },
  {
    name: 'Is Reimbursed',
    key: 'isReimbursed',
    editSortOrder: 13,
    editConfig: {
      type: 'Switch',
      isEditField: true,
      isAddField: true
    }
  },
  {
    name: 'Property Allocation Percent',
    key: 'propertyAllocationPercent',
    type: 'Child',
    isVisible: true,
    isRequired: true,
    editSortOrder: 7,
    editConfig: {
      type: 'TextNumber',
      isEditField: true,
      isAddField: true,
      isAvoidFormatting: true
    },
    rules: {
      And: [
        {
          operator: Operators.GreaterThanEqualsTo,
          key: 'propertyBillingPercent',
          displayName: 'Property Billing Percent'
        },
        {
          operator: Operators.GreaterThanEqualsTo,
          key: '',
          value: 0
        }
      ]
    },
    dependentFieldValidation: ['propertyBillingPercent']
  },
  {
    name: 'Total Approved Employee Property Allocation %', // 'Current Overall Property Allocation',
    key: 'overallPropertyAllocationPercent',
    type: 'Child',
    editSortOrder: 20,
    hideWhen: [{ key: "allocationType", value: "Market" }],
    applyColorBadge: true
  },
  {
    name: 'Property Billing Percent',
    key: 'propertyBillingPercent',
    type: 'Child',
    isRequired: true,
    isVisible: true,
    editSortOrder: 14,
    editConfig: {
      type: 'TextNumber',
      isEditField: true,
      isAddField: true,
      hideWhen: [{ key: "isReimbursed", value: false }],
      isAvoidFormatting: true
    },
    dependentValidation: { key: "isReimbursed", value: true },
    rules: {
      And: [
        {
          operator: Operators.LessThanEqualsTo,
          key: 'propertyAllocationPercent',
          displayName: 'Property Allocation Percent'
        },
        {
          operator: Operators.GreaterThanEqualsTo,
          key: '',
          value: 0
        }
      ]
    },
    dependentFieldValidation: ['propertyAllocationPercent']
  },
  {
    name: "Total Approved Employee Property Billing %", // "Current Overall Property Billing",
    key: "overallPropertyBillingPercent",
    type: "Child",
    editSortOrder: 19,
    applyColorBadge: true,
    editConfig: {
      hideWhen: [{ key: "isReimbursed", value: false }]
    }
  },
  {
    name: 'Flat Fee Amount',
    key: 'additionalFixedAmount',
    type: 'Child',
    displayFormat: 'MoneyDecimal',
    isVisible: true,
    editSortOrder: 16,
    editConfig: {
      type: 'TextNumber',
      isEditField: true,
      isAddField: true,
      isAvoidFormatting: true,
      hideWhen: [{ key: "isReimbursed", value: false }]
    },
    notEditWhen: { key: "isReimbursed", value: false },
    dependentValidation: { key: "isReimbursed", value: true },
    rules: {
      And: [
        {
          operator: Operators.GreaterThanEqualsTo,
          key: '',
          value: 0
        }
      ]
    }
  },
  {
    name: 'Status',
    key: 'approvalStatus',
    type: 'Child',
    dynamicRenderForm: 'legalEntityAndPropertyData',
    editSortOrder: 24
  },
  {
    name: 'Created By',
    key: 'createdBy',
    type: 'Child',
    editSortOrder: 25,
    showInEditOnly: true
  },
  {
    name: 'Created On',
    key: 'createdOn',
    type: 'Child',
    dataFormat: 'Date',
    editSortOrder: 26,
    showInEditOnly: true
  },
  {
    name: 'Modified By',
    key: 'lastModifiedBy',
    type: 'Child',
    editSortOrder: 27,
    showInEditOnly: true
  },
  {
    name: 'Modified On',
    key: 'lastModifiedOn',
    type: 'Child',
    dataFormat: 'Date',
    editSortOrder: 28,
    showInEditOnly: true
  },
  {
    name: 'Approved By',
    key: 'approvedBy',
    type: 'Child',
    editSortOrder: 29,
    showInEditOnly: true
  },
  {
    name: 'Approved On',
    key: 'approvedOn',
    type: 'Child',
    dataFormat: 'Date',
    editSortOrder: 30,
    showInEditOnly: true
  },

  {
    name: 'Action',
    key: 'marketId',
    type: 'Child',
    renderComponent: 'renderActionColumn',
    minWidth: 80
  }
];

export const propertyAllocationNew = [

  {
    name: 'Market',
    key: 'marketName',
    type: 'Child',
    isRequired: true,
    isVisible: true,
    editSortOrder: 1,
    editConfig: {
      type: 'DropDown',
      sourceKey: 'marketMasterData',
      updateKey: 'marketId',
      sourceOption: 'marketName',
      title: 'Market Name',
      isEditField: true,
      isAddField: true
    }
  },
  {
    name: 'Employee Name',
    key: 'preferredName',
    type: 'Parent',
    fieldId: 'employeeId',
    isVisible: true,
    isRequired: true,
    editSortOrder: 2,
    editConfig: {
      type: 'DropDown',
      sourceKey: 'employeeMasterData',
      updateKey: 'employeeId',
      sourceOption: 'employeeName',
      title: 'Employee Name',
      isEditField: false,
      isAddField: true
    },
    filterSourceOn: [
      { key: 'marketId', filterBy: 'marketId' }
    ]
  },
  {
    name: "Department",
    key: "departmentName",
    editSortOrder: 3
  },
  {
    name: "Is Allocated to Legal Entity",
    key: "isAllocatedToLegalEntity",
    editSortOrder: 9,
    editConfig: {
      type: "Switch",
      isEditField: true,
      isAddField: true
    },
    hideWhen: [{ key: "allocationType", value: "Market" }]
  },
  {
    name: "Property Name",
    key: "propertyName",
    type: "Child",
    fieldId: 'propertyId',
    isVisible: true,
    editSortOrder: 10,
    editConfig: {
      type: 'DropDown',
      sourceKey: 'propertyMasterData',
      updateKey: 'propertyId',
      sourceOption: 'propertyName',
      title: 'Property Name',
      isEditField: true,
      isAddField: true,
      distinctOn: "propertyId",
      hideWhen: [{ key: "isAllocatedToLegalEntity", value: true }]
    },
    dependentValidation: { key: "isAllocatedToLegalEntity", value: false },
    filterSourceOn: [
      { key: 'marketId', filterBy: 'marketId' }
    ],
    hideWhen: [{ key: "allocationType", value: "Market" }],
    notEditWhen: { key: "allocationType", value: "Market" }
  },
  {
    name: "Legal Entity",
    key: "legalEntity",
    type: "Child",
    fieldId: 'legalEntityId',
    isVisible: true,
    editSortOrder: 11,
    editConfig: {
      type: "DropDown",
      sourceKey: "propertyMasterData",
      updateKey: "legalEntityId",
      sourceOption: "legalEntity",
      title: "Legal Entity Name",
      isEditField: true,
      isAddField: true,
      distinctOn: "legalEntity",
      hideWhen: [{ key: "isAllocatedToLegalEntity", value: false }]
    },
    filterSourceOn: [
      { key: 'marketId', filterBy: 'marketId' }
    ],
    dependentValidation: { key: "isAllocatedToLegalEntity", value: true },
    hideWhen: [{ key: "allocationType", value: "Market" }],
    notEditWhen: { key: "allocationType", value: "Market" }
  },

  {
    name: 'Property Type',
    key: 'propertyTypeName',
    editSortOrder: 12,
    type: 'Child'
  },

  {
    name: 'Allocation Start Date',
    key: 'allocationStartDate',
    isRequired: true,
    isVisible: true,
    editSortOrder: 4,
    type: 'Child',
    dataFormat: 'Date',
    editConfig: {
      type: 'DatePicker',
      isEditField: true,
      isAddField: true
    },
    rules: {
      And: [
        {
          operator: Operators.LessThan,
          key: 'allocationEndDate',
          displayName: 'Allocation End Date'
        }
      ]
    }
  },
  {
    name: 'Allocation End date',
    key: 'allocationEndDate',
    editSortOrder: 5,
    type: 'Child',
    dataFormat: 'Date',
    editConfig: {
      type: 'DatePicker',
      isEditField: true,
      isAddField: true
    },
    rules: {
      And: [
        {
          operator: Operators.GreaterThan,
          key: 'allocationStartDate',
          displayName: 'Allocation Start Date'
        }
      ]
    }
  },
  {
    name: 'Billing Start Date',
    key: 'billingStartDate',
    type: 'Child',
    isRequired: true,
    isVisible: true,
    editSortOrder: 7,
    dataFormat: 'Date',
    editConfig: {
      type: 'DatePicker',
      isEditField: true,
      isAddField: true
    },
    rules: {
      And: [
        {
          operator: Operators.LessThan,
          key: 'billingEndDate',
          displayName: 'Billing End Date'
        },
        {
          operator: Operators.LessThanEqualsTo,
          key: 'allocationEndDate',
          displayName: 'Allocation End Date'
        },
        {
          operator: Operators.GreaterThanEqualsTo,
          key: 'allocationStartDate',
          displayName: 'Allocation Start Date'
        }
      ]
    }
  },
  {
    name: 'Billing End Date',
    key: 'billingEndDate',
    type: 'Child',
    isVisible: true,
    editSortOrder: 8,
    dataFormat: 'Date',
    editConfig: {
      type: 'DatePicker',
      isEditField: true,
      isAddField: true
    },
    rules: {
      And: [
        {
          operator: Operators.GreaterThan,
          key: 'billingStartDate',
          displayName: 'Billing Start Date'
        },
        {
          operator: Operators.LessThanEqualsTo,
          key: 'allocationEndDate',
          displayName: 'Allocation End Date'
        },
        {
          operator: Operators.LessThanEqualsTo,
          key: 'allocationEndDate',
          displayName: 'Allocation End Date'
        }
      ]
    }
  },
  {
    name: 'Is Reimbursed',
    key: 'isReimbursed',
    editSortOrder: 13,
    editConfig: {
      type: 'Switch',
      isEditField: true,
      isAddField: true
    }
  },
  {
    name: 'Property Allocation Percent',
    key: 'propertyAllocationPercent',
    type: 'Child',
    isVisible: true,
    isRequired: true,
    editSortOrder: 6,
    editConfig: {
      type: 'TextField',
      isEditField: true,
      isAddField: true
    }
  },
  {
    name: 'Total Approved Employee Property Allocation %', // 'Current Overall Property Allocation',
    key: 'overallPropertyAllocationPercent',
    type: 'Child',
    editSortOrder: 20,
    hideWhen: [{ key: "allocationType", value: "Market" }],
    applyColorBadge: true
  },
  {
    name: 'Property Billing Percent',
    key: 'propertyBillingPercent',
    type: 'Child',
    isRequired: true,
    isVisible: true,
    editSortOrder: 14,
    editConfig: {
      type: 'TextField',
      isEditField: true,
      isAddField: true,
      hideWhen: [{ key: "isReimbursed", value: false }]
    },
    dependentValidation: { key: "isReimbursed", value: true },
    rules: {
      And: [
        {
          operator: Operators.LessThanEqualsTo,
          key: 'propertyAllocationPercent',
          displayName: 'Property Allocation Percent'
        }
      ]
    }
  },
  {
    name: "Total Approved Employee Property Billing %", // "Current Overall Property Billing",
    key: "overallPropertyBillingPercent",
    type: "Child",
    editSortOrder: 19,
    applyColorBadge: true,
    editConfig: {
      hideWhen: [{ key: "isReimbursed", value: false }]
    }
  },
  {
    name: 'Flat Fee Amount',
    key: 'additionalFixedAmount',
    type: 'Child',
    displayFormat: 'MoneyDecimal',
    isVisible: true,
    editSortOrder: 16,
    editConfig: {
      type: 'TextField',
      isEditField: true,
      isAddField: true,
      hideWhen: [{ key: "isReimbursed", value: false }]
    },
    notEditWhen: { key: "isReimbursed", value: false },
    dependentValidation: { key: "isReimbursed", value: true }
  },
  {
    name: 'Status',
    key: 'approvalStatus',
    type: 'Child',
    dynamicRenderForm: 'legalEntityAndPropertyData'
  }

  // {
  //   name: 'Action',
  //   key: 'marketId',
  //   type: 'Child',
  //   renderComponent: 'renderActionColumn'
  // }
];

export const propertyallocationConfig = {
  collapsible: false,
  groupBy: 'employeeId',
  groupByWith: 'propertyName',
  inLineGroupBlock: true,
  showPager: true
};

export const allocationConfig = {
  collapsible: false,
  groupBy: 'employeeId',
  inLineGroupBlock: false,
  showPager: true
};

export const assignmentColumns = [
  { name: 'Assignment', key: 'assignmentName', type: 'Parent' },
  { name: 'Service Type', key: 'serviceType', type: 'Parent' },
  { name: 'Start Date', key: 'startDate', type: 'Child', minWidth: 100 },
  { name: 'End Date', key: 'endDate', type: 'Child', minWidth: 100 },
  { name: 'Signed On', key: 'signedDate', type: 'Child', minWidth: 100 },
  { name: 'Market', key: 'marketName', type: 'Child' },
  { name: 'Property Name', key: 'propertyName', type: 'Child' },
  { name: 'Notes', key: 'assignemntDescription', type: 'Parent' },
  { name: 'Status', key: 'statusName', type: 'Child' },
  {
    name: 'Action',
    key: 'marketId',
    type: 'Child',
    renderComponent: 'renderActionColumn',
    minWidth: 80
  }
];

export const assignmentConfig = {
  collapsible: false,
  groupBy: 'assignmentId',
  inLineGroupBlock: false
};

export const transitionTrackerListColumns = [
  { name: 'Property Name', key: 'propertyName', type: 'Parent' },
  { name: 'Client', key: 'propertyName', type: 'Parent' },
  { name: 'Location', key: 'location', type: 'Parent' },
  { name: 'Market', key: 'marketName', type: 'Parent' },
  { name: 'Property Type', key: 'propertyType', type: 'Parent' },
  {
    name: 'TransitionDate',
    key: 'transitionDate',
    type: 'Parent',
    dataFormat: 'Date'
  },
  { name: 'Status', key: 'status', type: 'Parent' },
  { name: 'Controller', key: 'controller', type: 'Parent' },
  {
    name: 'Action',
    key: 'Property Name',
    type: 'Child',
    renderComponent: 'renderActionColumn',
    minWidth: 80
  }
];

export const transitionTrackerList = [
  {
    propertyName: 'DI El Paso Logistics Park Phase I, LP,',
    client: 'VanTrust',
    location: 'El Paso (SAU)',
    marketName: 'SAU - Austin',
    propertyType: 'Industrial',
    transitionDate: '3/18/2021',
    status: 'In Progress',
    controller: ' Unassigned'
  },
  {
    propertyName: '5209 Burnett',
    client: 'Pennybacker Capital',
    location: 'Austin',
    marketName: 'SAU - Austin',
    propertyType: 'Office',
    transitionDate: '3/18/2021',
    status: 'Not Started',
    controller: ' Unassigned'
  },
  {
    propertyName: 'Stream Pecan Holdings',
    client: 'Fund Bravo',
    location: 'Houston',
    marketName: 'SHO - Houston',
    propertyType: 'Investment',
    transitionDate: '1/14/2021',
    status: 'Completed',
    controller: 'Lewis'
  }
];

export const transitionStatusMaster = [
  { statusId: 1, status: 'Not Started' },
  { statusId: 2, status: 'In Progress' },
  { statusId: 3, status: 'Completed' }
];

export const transitionTrackerSteps = [
  {
    TrackerId: 0,
    PropertyTransitionId: 0,
    PropertyId: 0,
    IsApplicable: true,
    IsCompleted: true,
    Value: 'Joe Valles',
    Comments: 'Added joe Valles as Project Lead',
    CompletedBy: 'Tran',
    CompletedOn: '1/14/2021',
    propertyTransitionTrackerStepId: 1,
    name: 'Assigned Project Lead (Acctg Mgr/Managing Sr)'
  },
  {
    TrackerId: 0,
    PropertyTransitionId: 0,
    PropertyId: 0,
    IsApplicable: true,
    IsCompleted: 0,
    Value: '',
    Comments: '',
    CompletedBy: '',
    CompletedOn: '',
    propertyTransitionTrackerStepId: 2,
    name: 'Assigned Accountant'
  },
  {
    TrackerId: 0,
    PropertyTransitionId: 0,
    PropertyId: 0,
    IsApplicable: false,
    IsCompleted: 0,
    Value: '',
    Comments: '',
    CompletedBy: '',
    CompletedOn: '',
    propertyTransitionTrackerStepId: 3,
    name: 'AR Admin(if applicable)'
  },
  {
    TrackerId: 0,
    PropertyTransitionId: 0,
    PropertyId: 0,
    IsApplicable: true,
    IsCompleted: 0,
    Value: '',
    Comments: '',
    CompletedBy: '',
    CompletedOn: '',
    propertyTransitionTrackerStepId: 4,
    name: 'Initial Transition Call'
  },
  {
    TrackerId: 0,
    PropertyTransitionId: 0,
    PropertyId: 0,
    IsApplicable: false,
    IsCompleted: 0,
    Value: '',
    Comments: '',
    CompletedBy: '',
    CompletedOn: '',
    propertyTransitionTrackerStepId: 5,
    name: 'Bank Setup'
  },
  {
    TrackerId: 0,
    PropertyTransitionId: 0,
    PropertyId: 0,
    IsApplicable: true,
    IsCompleted: 0,
    Value: '',
    Comments: '',
    CompletedBy: '',
    CompletedOn: '',
    propertyTransitionTrackerStepId: 6,
    name: 'Yardi Setup'
  },
  {
    TrackerId: 0,
    PropertyTransitionId: 0,
    PropertyId: 0,
    IsApplicable: true,
    IsCompleted: 0,
    Value: '',
    Comments: '',
    CompletedBy: '',
    CompletedOn: '',
    propertyTransitionTrackerStepId: 7,
    name: 'AVID Setup'
  },
  {
    TrackerId: 0,
    PropertyTransitionId: 0,
    PropertyId: 0,
    IsApplicable: true,
    IsCompleted: 0,
    Value: '',
    Comments: '',
    CompletedBy: '',
    CompletedOn: '',
    propertyTransitionTrackerStepId: 8,
    name: '1st Check Run'
  },
  {
    TrackerId: 0,
    PropertyTransitionId: 0,
    PropertyId: 0,
    IsApplicable: true,
    IsCompleted: 0,
    Value: '',
    Comments: '',
    CompletedBy: '',
    CompletedOn: '',
    propertyTransitionTrackerStepId: 9,
    name: 'Debt Service'
  },
  {
    TrackerId: 0,
    PropertyTransitionId: 0,
    PropertyId: 0,
    IsApplicable: true,
    IsCompleted: 0,
    Value: '',
    Comments: '',
    CompletedBy: '',
    CompletedOn: '',
    propertyTransitionTrackerStepId: 10,
    name: 'Closing/Beginning Entries'
  },
  {
    TrackerId: 0,
    PropertyTransitionId: 0,
    PropertyId: 0,
    IsApplicable: true,
    IsCompleted: 0,
    Value: '',
    Comments: '',
    CompletedBy: '',
    CompletedOn: '',
    propertyTransitionTrackerStepId: 11,
    name: 'Tenant Ledger'
  },
  {
    TrackerId: 0,
    PropertyTransitionId: 0,
    PropertyId: 0,
    IsApplicable: true,
    IsCompleted: 0,
    Value: '',
    Comments: '',
    CompletedBy: '',
    CompletedOn: '',
    propertyTransitionTrackerStepId: 12,
    name: 'Current Year Budget'
  },
  {
    TrackerId: 0,
    PropertyTransitionId: 0,
    PropertyId: 0,
    IsApplicable: true,
    IsCompleted: 0,
    Value: '',
    Comments: '',
    CompletedBy: '',
    CompletedOn: '',
    propertyTransitionTrackerStepId: 13,
    name: '1st Management Fee'
  },
  {
    TrackerId: 0,
    PropertyTransitionId: 0,
    PropertyId: 0,
    IsApplicable: true,
    IsCompleted: 0,
    Value: '',
    Comments: '',
    CompletedBy: '',
    CompletedOn: '',
    propertyTransitionTrackerStepId: 14,
    name: '1st Month Report'
  },
  {
    TrackerId: 0,
    PropertyTransitionId: 0,
    PropertyId: 0,
    IsApplicable: true,
    IsCompleted: 0,
    Value: '',
    Comments: '',
    CompletedBy: '',
    CompletedOn: '',
    propertyTransitionTrackerStepId: 15,
    name:
      '1st Month Review checklist has been approved by PM, Accountant and Reviewer and is saved to the building folder'
  },
  {
    TrackerId: 0,
    PropertyTransitionId: 0,
    PropertyId: 0,
    IsApplicable: true,
    IsCompleted: 0,
    Value: '',
    Comments: '',
    CompletedBy: '',
    CompletedOn: '',
    propertyTransitionTrackerStepId: 16,
    name:
      'Accounting Transition checklist is approved and saved to the building folder'
  },
  {
    TrackerId: 0,
    PropertyTransitionId: 0,
    PropertyId: 0,
    IsApplicable: true,
    IsCompleted: 0,
    Value: '',
    Comments: '',
    CompletedBy: '',
    CompletedOn: '',
    propertyTransitionTrackerStepId: 17,
    name:
      'Bank account details have been sent to Banking for master bank file updates'
  }
];

export const burdenRateColumnsList = [
  {
    name: 'Burden Rate Name',
    key: 'burdenRate',
    type: 'Child',
    isRequired: true,
    isVisible: true,
    editConfig: {
      type: 'TextField',
      isEditField: false,
      isAddField: true
    }
  },
  {
    name: 'Title',
    key: 'designation',
    idField: 'designationId',
    isRequired: true,
    isVisible: true,
    minTag: 5,
    editConfig: {
      type: 'DropDown',
      sourceKey: 'designationMasterData',
      updateKey: 'designationId',
      sourceOption: 'designation',
      title: 'Department',
      isEditField: true,
      isAddField: true,
      multiple: true,
      delimiter: '|'
    }
  },
  {
    name: 'Burden Rate %',
    key: 'burdenRatePercent',
    type: 'Child',
    dataFormat: 'DecimalPercent',
    isRequired: true,
    isVisible: true,
    editConfig: {
      type: 'TextNumber', // 'TextField',
      isEditField: true,
      isAddField: true
    }
  },
  {
    name: 'Applicable From',
    key: 'startDate',
    type: 'Child',
    dataFormat: 'Date',
    isRequired: true,
    isVisible: true,
    editConfig: {
      type: 'DatePicker',
      isEditField: true,
      isAddField: true,
      shouldDisableDate: disableDatesForPayCycleStart1
    }
  },
  {
    name: 'Applicable Till',
    key: 'endDate',
    type: 'Child',
    dataFormat: 'Date'
  },

  {
    name: 'Action',
    key: 'burdenRateId',
    renderComponent: 'renderActionColumn',
    minWidth: 70
  }
];

export const designationThresholdColumnsList = [
  {
    name: 'Account Code Name',
    key: 'designationGroup',
    type: 'Child',
    isRequired: true,
    isVisible: true,
    editConfig: {
      title: 'Category Name',
      type: 'TextField',
      isEditField: true,
      isAddField: true
    }
  },
  {
    name: 'Title',
    key: 'designation',
    idField: 'designationId',
    isRequired: true,
    isVisible: true,
    minTag: 5,
    editConfig: {
      type: 'DropDown',
      sourceKey: 'designationMasterData',
      updateKey: 'designationId',
      sourceOption: 'designation',
      title: 'Designation',
      isEditField: true,
      isAddField: true,
      multiple: true,
      delimiter: '|'
    }
  },
  {
    name: 'Variance Threshold',
    key: 'threshold',
    type: 'Child',
    isRequired: true,
    isVisible: true,
    dataFormat: 'MoneyDecimal',
    editConfig: {
      type: 'TextNumber',
      isEditField: true,
      isAddField: true
    }
  },
  {
    name: 'Action',
    key: 'designationGroupId',
    renderComponent: 'renderActionColumn',
    minWidth: 80
  }
];
export const serviceTypeMappingColumns = [
  {
    name: 'Service Type',
    key: 'serviceType',
    width: 300
  },
  {
    name: 'Notify To',
    key: 'email',
    isEditable: true,
    isRequired: true,
    dataFormat: 'MultiText',
    minTag: 2,
    editConfig: {
      type: 'ChipInput',
      title: 'Notify To',
      isEditField: true,
      isAddField: true,
      multiple: true
    }
  },
  {
    name: 'CC Email',
    key: 'emailCc',
    isEditable: true,
    dataFormat: 'MultiText',
    minTag: 2,
    editConfig: {
      type: 'ChipInput',
      title: 'CC Email',
      isEditField: true,
      isAddField: true,
      multiple: true
    }
  },
  {
    name: 'BCC Email',
    key: 'emailBcc',
    minTag: 2,
    isEditable: true,
    dataFormat: 'MultiText',
    editConfig: {
      type: 'ChipInput',
      title: 'BCC Email',
      isEditField: true,
      isAddField: true,
      multiple: true
    }
  },
  {
    name: 'Action',
    minWidth: 80,
    key: 'serviceTypeId', // emailMappingId
    renderComponent: 'renderActionColumn'
  }
];

export const userMarketMappingColumnData = [
  {
    name: 'User Email',
    key: 'userEmail',
    type: 'Parent',
    fieldId: 'employeeId',
    isRequired: true,
    isVisible: true,
    editSortOrder: 2,
    editConfig: {
      type: 'DropDown',
      sourceKey: 'employeeMasterData',
      updateKey: 'employeeId',
      sourceOption: 'email',
      title: 'Employee Name',
      isEditField: true,
      isAddField: true
    }
  },
  {
    name: 'Market',
    key: 'marketName',
    minTag: 2,
    viewTagData: 'viewTagData',
    isRequired: true,
    isVisible: true,
    editConfig: {
      type: 'DropDown',
      sourceKey: 'marketMasterData',
      updateKey: 'marketId',
      sourceOption: 'marketName',
      title: 'Market',
      isEditField: true,
      isAddField: true,
      multiple: true,
      delimiter: '|'
    }
  },
  {
    name: 'Show Reimbursement Amount for SRP Market',
    key: 'reimbursementAmountAccess',
    isVisible: true,
    isTooltip: true,
    tooltip: 'Enables the “SRP-Stream Realty Partners” Market Reimbursement Amounts to be shown for all Reimbursement Reports',
    editConfig: {
      type: 'CheckBox',
      isEditField: true,
      isAddField: true
    }
  },
  {
    name: 'Billing/Accounting, Pay Period/Year End Closure and OT Timesheet Rights',
    key: 'billingAdjustmentAccess',
    isVisible: true,
    isTooltip: true,
    tooltip: 'Enables the Close Year End Bonus Period, Close Pay Period, Billing/Accounting and OT Timesheet screens',
    editConfig: {
      type: 'CheckBox',
      isEditField: true,
      isAddField: true
    }
  },
  {
    name: 'Is Eligible for Compliance',
    key: 'complianceAccess',
    isVisible: true,
    isTooltip: true,
    tooltip: 'Enables  the “Allocation Due” Banner and Emails notifications Reminders to be sent',
    editConfig: {
      type: 'CheckBox',
      isEditField: true,
      isAddField: true
    }
  },
  {
    name: 'Is Year End Bonus',
    key: 'yearEndBonusAccess',
    isVisible: true,
    isTooltip: true,
    tooltip: 'Enables the Year End Bonus Estimation and Review Banner and Estimation and Accrual Screens',
    editConfig: {
      type: 'CheckBox',
      isEditField: true,
      isAddField: true
    }
  },
  {
    name: 'Action',
    minWidth: 80,
    key: 'marketAccessPermissionId',
    renderComponent: 'renderActionColumn'
  }
];

export const serviceTypeMappingColumnList = [

  {
    name: 'Service Type',
    key: 'serviceType'
  },
  {
    name: 'Department',
    key: 'departmentName',
    minTag: 2,
    viewTagData: 'viewTagData',
    isRequired: true,
    isVisible: true,
    editConfig: {
      type: 'DropDown',
      sourceKey: 'departmentMasterData',
      updateKey: 'departmentId',
      sourceOption: 'departmentName',
      title: 'Department',
      isEditField: true,
      isAddField: true,
      multiple: true,
      delimiter: '|'
    }
  },
  {
    name: 'Group',
    key: 'accessGroup',
    editConfig: {
      type: 'DropDown',
      sourceKey: 'groupMasterData',
      updateKey: 'accessGroupId',
      sourceOption: 'accessGroupName',
      title: 'Group Name',
      isEditField: true,
      isAddField: true,
      multiple: true,
      delimiter: '|'
    }
  },
  {
    name: 'Read Only Group',
    key: 'readOnlyAccessGroup',
    editConfig: {
      type: 'DropDown',
      sourceKey: 'groupMasterData',
      updateKey: 'accessGroupId',
      sourceOption: 'accessGroupName',
      title: 'Read Only Group',
      isEditField: true,
      isAddField: true,
      multiple: true,
      delimiter: '|'
    },
    filterSourceOn: [{ key: 'accessGroupId', filterBy: 'accessGroupId' }],
    filterOnSameSource: true
  },
  {
    name: 'Action',
    key: 'accessGroupId',
    renderComponent: 'renderActionColumn',
    minWidth: 80
  }
];

export const serviceTypePayCodeMappingColumnList = [

  {
    name: 'Service Type',
    key: 'serviceType'
  },
  {
    name: 'Paycode',
    key: 'payCode',
    minTag: 2,
    isRequired: true,
    isVisible: true,
    viewTagData: 'viewTagData',
    editConfig: {
      type: 'DropDown',
      sourceKey: 'paycodeMasterData',
      updateKey: 'payCodeId',
      sourceOption: 'payCode',
      title: 'PayCode',
      isEditField: true,
      isAddField: true,
      multiple: true,
      delimiter: '|'
    }
  },
  {
    name: 'Action',
    key: 'serviceTypeId',
    renderComponent: 'renderActionColumn',
    minWidth: 80
  }
];

// column list of expense Groups and Pay codes mapping
export const expenseGroupMappingColumnList = [
  {
    name: 'Paycode',
    key: 'payCode',
  },
  {
    name: 'Streamline Paycode',
    key: 'streamlinePayCode',
  },
  {
    name: 'Paycode Type',
    key: 'payCodeType',
    type: 'Parent',
    isRequired: true,
    isVisible: true,
    fieldId: 'payCodeTypeId',
    editSortOrder: 1,
    editConfig: {
      type: 'DropDown',
      sourceKey: 'paycodeTypeMasterData',
      updateKey: 'payCodeTypeId',
      sourceOption: 'payCodeType',
      title: 'Paycode Type',
      isEditField: true,
      isAddField: true,
      distinctOn: "payCodeType"
    }
  },
  {
    name: 'Expense Group',
    key: 'expenseGroup',
    type: 'Parent',
    isRequired: true,
    isVisible: true,
    fieldId: 'expenseGroupId',
    editSortOrder: 2,
    editConfig: {
      type: 'DropDown',
      sourceKey: 'expenseGroupMasterData',
      updateKey: 'expenseGroupId',
      sourceOption: 'expenseGroup',
      title: 'Expense Group',
      isEditField: true,
      isAddField: true,
      distinctOn: "expenseGroup"
    }
  },
  {
    name: 'Paycode Applicable For',
    key: 'paycodeApplicableFor',
    isVisible: true,
    isRequired: true,
    fieldId: 'paycodeApplicableForId',
    editSortOrder: 3,
    editConfig: {
      type: 'DropDown',
      sourceKey: 'paycodeApplicableForSourceData',
      updateKey: 'paycodeApplicableForId',
      sourceOption: 'paycodeApplicableFor',
      title: 'paycodeApplicableFor',
      isEditField: true,
      isAddField: true,
      distinctOn: "paycodeApplicableFor"
    }
  },
  {
    name: 'Action',
    key: 'serviceTypeId',
    renderComponent: 'renderActionColumn',
    minWidth: 80
  }
];

// column list of Employee Title Configuration
export const employeeTitlesMappingColumnList = [
  {
    name: 'Title',
    key: 'designation',
  },
  {
    name: 'Is Mapping Required',
    key: 'isMappingRequired',
    isVisible: true,
    editConfig: {
      type: 'CheckBox',
      isEditField: true,
      isAddField: true
    }
  },
  {
    name: 'Action',
    key: 'designationID',
    renderComponent: 'renderActionColumn',
    minWidth: 80
  }
];

export const radioValue = [
  {
    value: 'departmentName',
    label: 'Department Level',
    sortOrder: ['marketName', 'departmentName', 'division'],
    showWhen: { allocationType: 'Market' },
    groupBy: ['MarketName', 'DepartmentName', 'Division']
  },
  {
    value: 'division',
    label: 'Division Level',
    sortOrder: ['marketName', 'division', 'departmentName'],
    showWhen: { allocationType: 'Market' },
    groupBy: ['MarketName', 'Division', 'DepartmentName']

  },
  // {
  //   value: 'category',
  //   label: 'Account Code Name Level',
  //   sortOrder: ['marketName', 'category', 'departmentName', 'division'],
  //   showWhen: { allocationType: 'Market' }

  // },
  // {
  //   value: 'departmentName',
  //   label: 'Department Level',
  //   sortOrder: ['marketName', 'departmentName', 'clientName', 'legalEntity', 'category', 'propertyName'],
  //   showWhen: { allocationType: 'Property' }

  // },
  // {
  //   value: 'clientName',
  //   label: 'Client Level',
  //   sortOrder: ['marketName', 'clientName', 'departmentName', 'legalEntity', 'category', 'propertyName'],
  //   showWhen: { allocationType: 'Property' }

  // },
  {
    value: 'customer',
    label: 'Customer/Legal Entity Level',
    sortOrder: ['marketName', 'legalEntity', 'category'],
    showWhen: { allocationType: 'Property' },
    groupBy: ['MarketName', 'LegalEntity', 'Category']
  },
  {
    value: 'category',
    label: 'Account Code Name  Level  ',
    sortOrder: ['marketName', 'category', 'legalEntity'],
    showWhen: { allocationType: 'Property' },
    groupBy: ['MarketName', 'Category', 'LegalEntity']
  }
  // {
  //   value: 'propertyColumn',
  //   label: 'Property Level',
  //   sortOrder: ['marketName', 'propertyName', 'departmentName', 'clientName', 'legalEntity', 'category'],
  //   showWhen: { allocationType: 'Property' }
  // }
];

export const propertyAccountingPayrollColumnList = [
  {
    name: 'Applicable From',
    key: 'applicableFrom',
    type: 'Child',
    isRequired: true,
    isVisible: true,
    isPayCycle: true,
    minDate: '01/01/1900',
    dataFormat: 'Date',
    editConfig: {
      type: 'DatePicker',
      isEditField: true,
      isAddField: true
    }
  },
  {
    name: 'Configuration Type',
    key: 'configurationType',
    type: 'Parent',
    fieldId: 'payrollConfigurationTypeId',
    isVisible: true,
    isRequired: true,
    editSortOrder: 1,
    editConfig: {
      type: 'DropDown',
      sourceKey: 'payrollConfigurationType',
      updateKey: 'payrollConfigurationTypeId',
      sourceOption: 'configurationType',
      title: 'Configuration Type',
      isEditField: false,
      isAddField: true,
      distinctOn: "payrollConfigurationTypeId"
    }
  },
  {
    name: 'Payroll',
    key: 'payroll',
    type: 'Child',
    displayFormat: 'MoneyDecimal',
    dataFormat: 'MoneyDecimal',
    isRequired: true,
    isVisible: true,
    editConfig: {
      isAvoidFormatting: true,
      type: 'TextNumber', // 'TextField',
      isEditField: true,
      isAddField: true
    }
  },
  {
    name: 'Bonus',
    key: 'bonus',
    type: 'Child',
    displayFormat: 'MoneyDecimal',
    dataFormat: 'MoneyDecimal',
    isRequired: true,
    isVisible: true,
    editConfig: {
      isAvoidFormatting: true,
      isAddField: true,
      isEditField: true,
      type: 'TextNumber' // 'TextField',
    }
  },
  {
    name: 'Burden Rate %',
    key: 'burdenRatePercent',
    type: 'Child',
    dataFormat: 'Number',
    displayFormat: 'Number',
    isRequired: true,
    isVisible: true,
    editConfig: {
      isAvoidFormatting: true,

      type: 'TextNumber', // 'TextField',
      isEditField: true,
      isAddField: true
    }
  },
  {
    name: 'Total Reimbursement Cost',
    key: 'totalReimbursementCost',
    type: 'Child',
    dataFormat: 'MoneyDecimal',
    isRequired: false,
    isVisible: true,
    editConfig: {
      isAvoidFormatting: true,
      type: 'TextField',
      isEditField: false,
      isAddField: false
    }
  },
  {
    name: 'Action',
    minWidth: 80,
    key: 'propertyAccountingPayrollConfigurationId',
    renderComponent: 'renderActionColumn'
  }
];

export const DatacenterEmployeeBonusPercentColumnList = [
  {
    name: 'Employee Name',
    key: 'preferredName',
    type: 'Parent',
    fieldId: 'employeeId',
    isVisible: true,
    isRequired: true,
    editSortOrder: 1,
    editConfig: {
      type: 'DropDown',
      sourceKey: 'employeeMasterData',
      updateKey: 'employeeId',
      sourceOption: 'employeeName',
      title: 'Employee Name',
      isEditField: false,
      isAddField: true,
      distinctOn: "employeeId"
    }
    // dependentFieldValidation: ['budgetedPercent']
  },
  {
    name: 'Applicable From',
    key: 'applicableFrom',
    type: 'Child',
    dataFormat: 'Date',
    isRequired: true,
    isVisible: true,
    isPayCycle: true,
    editConfig: {
      type: 'DatePicker',
      isEditField: true,
      isAddField: true
    },
    rules: {
      And: [
        {
          operator: Operators.GreaterThanEqualsTo,
          key: 'minDate',
          displayName: 'Current Pay Period Start Date.'
        }
      ]
    }
  },
  {
    name: 'Multiplier',
    key: 'multiplier',
    type: 'Child',
    displayFormat: 'Decimal',
    dataFormat: 'Decimal',
    isRequired: true,
    isVisible: true,
    editConfig: {
      isAvoidFormatting: true,
      type: 'TextNumber', // 'TextField',
      isEditField: true,
      isAddField: true
    },
    rules: {
      And: [
        {
          operator: Operators.GreaterThanEqualsTo,
          key: '',
          value: 0
        }
      ]
    }
  },
  {
    name: 'Bonus %',
    key: 'bonus',
    type: 'Child',
    displayFormat: 'Number',
    dataFormat: 'Number',
    isRequired: true,
    isVisible: true,
    editConfig: {
      isAvoidFormatting: true,
      type: 'TextNumber', // 'TextField',
      isAddField: true,
      isEditField: true
    },
    rules: {
      And: [
        {
          operator: Operators.GreaterThanEqualsTo,
          key: '',
          value: 0
        }
      ]
    }
  },
  {
    name: 'Burden Rate %',
    key: 'burdenRatePercent',
    type: 'Child',
    dataFormat: 'Number',
    displayFormat: 'Number',
    isRequired: true,
    isVisible: true,
    editConfig: {
      isAvoidFormatting: true,

      type: 'TextNumber', // 'TextField',
      isEditField: true,
      isAddField: true
    },
    rules: {
      And: [
        {
          operator: Operators.GreaterThanEqualsTo,
          key: '',
          value: 0
        }
      ]
    }
  },
  {
    name: 'Action',
    minWidth: 80,
    key: 'BonusConfigurationId',
    renderComponent: 'renderActionColumn'
  }
];

export const DataCenterAccountingPayrollColumnList = [
  {
    name: 'Applicable From',
    key: 'applicableFrom',
    type: 'Child',
    isRequired: true,
    isVisible: true,
    isPayCycle: true,
    editConfig: {
      type: 'DatePicker',
      isEditField: true,
      isAddField: true
    },
    rules: {
      And: [
        {
          operator: Operators.GreaterThanEqualsTo,
          key: 'minDate',
          displayName: 'Current Pay Period Start Date.'
        }
      ]
    }
  },
  {
    name: 'Multiplier',
    key: 'multiplier',
    type: 'Child',
    displayFormat: 'Decimal',
    dataFormat: 'Decimal',
    isRequired: true,
    isVisible: true,
    editConfig: {
      isAvoidFormatting: true,
      type: 'TextNumber', // 'TextField',
      isEditField: true,
      isAddField: true
    },
    rules: {
      And: [
        {
          operator: Operators.GreaterThanEqualsTo,
          key: '',
          value: 0
        }
      ]
    }
  },
  {
    name: 'Bonus %',
    key: 'bonus',
    type: 'Child',
    displayFormat: 'Number',
    dataFormat: 'Number',
    isRequired: true,
    isVisible: true,
    editConfig: {
      isAvoidFormatting: true,
      type: 'TextNumber', // 'TextField',
      isAddField: true,
      isEditField: true
    },
    rules: {
      And: [
        {
          operator: Operators.GreaterThanEqualsTo,
          key: '',
          value: 0
        }
      ]
    }
  },
  {
    name: 'Burden Rate %',
    key: 'burdenRatePercent',
    type: 'Child',
    dataFormat: 'Number',
    displayFormat: 'Number',
    isRequired: true,
    isVisible: true,
    editConfig: {
      isAvoidFormatting: true,

      type: 'TextNumber', // 'TextField',
      isEditField: true,
      isAddField: true
    },
    rules: {
      And: [
        {
          operator: Operators.GreaterThanEqualsTo,
          key: '',
          value: 0
        }
      ]
    }
  },
  {
    name: 'Type',
    key: 'type',
    type: 'Child',
    isRequired: true,
    isVisible: true,
    editConfig: {
      type: 'DropDown',
      sourceKey: 'typeMasterData',
      updateKey: 'type',
      sourceOption: 'type',
      title: 'Type',
      isEditField: true,
      isAddField: true
    }
  },
  {
    name: 'Action',
    minWidth: 80,
    key: 'PayrollConfigurationId',
    renderComponent: 'renderActionColumn'
  }
];

export const DataCenterPropertySplitColumnList = [
  {
    name: 'Applicable From',
    key: 'applicableFrom',
    type: 'Child',
    dataFormat: "Date",
    isRequired: true,
    isVisible: true,
    isPayCycle: true,
    editConfig: {
      type: 'DatePicker',
      isEditField: true,
      isAddField: true
    },
    rules: {
      And: [
        {
          operator: Operators.GreaterThanEqualsTo,
          key: 'minDate'
        }
      ]
    }
  },
  {
    name: 'Property',
    key: 'property',
    type: 'Child',
    isRequired: true,
    isVisible: true,
    editConfig: {
      type: 'DropDown',
      sourceKey: 'propertyMasterData',
      updateKey: 'property',
      sourceOption: 'propertyName',
      title: 'Property',
      isEditField: true,
      isAddField: true
    }
  },
  {
    name: 'Leadership Allocation %',
    key: 'percentSplit',
    type: 'Child',
    dataFormat: 'DecimalPercent',
    displayFormat: 'DecimalPercent',
    isRequired: true,
    isVisible: true,
    editConfig: {
      isAvoidFormatting: true,

      type: 'TextNumber', // 'TextField',
      isEditField: true,
      isAddField: true
    },
    rules: {
      And: [
        {
          operator: Operators.GreaterThanEqualsTo,
          key: '',
          value: 0
        }
      ]
    }
  },
  {
    name: 'Action',
    minWidth: 80,
    key: 'PayrollConfigurationId',
    renderComponent: 'renderActionColumn'
  }
];

export const collapsableReimbursement =
{
  name: 'Reimbursement Cost',
  key: 'reimbursementCost',
  format: 'DecimalPercent',
  appendText: '$'
};

export const collapsableAllocationPercent =
{
  name: 'Allocation Percent',
  key: 'allocationRate',
  format: 'DecimalPercent',
  appendText: '%'
};

export const extendibleMarkerReimbursArray = [
  {
    name: 'Allocation Percent',
    key: 'allocationRate',
    format: 'DecimalPercent',
    appendText: '%',
    hideColumn: true
  },
  {
    name: 'Expense Amount',
    key: 'expenseAmount',
    format: 'MoneyNumber',
    // format: 'ReportHeader',
    appendText: '$',
    className: 'flat-rate-class'
  }
];

export const extendibleMarketArray = [
  {
    name: 'Allocation Percent',
    key: 'allocationRate',
    format: 'DecimalPercent',
    // format: 'ReportHeader',
    appendText: '%',
    hideColumn: true
  },
  {
    name: 'Burden Rate Percent',
    key: 'burdenRatePercent',
    format: 'DecimalPercent',
    // format: 'ReportHeader',
    appendText: '%',
    className: 'burden-rate-percent-class',
    hideColumn: true
  },
  {
    name: 'Billing Percent',
    key: 'propertyBillingPercent',
    format: 'DecimalPercent',
    // format: 'ReportHeader',
    appendText: '%',
    className: 'billing-percent-class',
    hideColumn: true
  },
  {
    name: 'Flat Rate',
    key: 'flatrate',
    format: 'MoneyNumber',
    // format: 'ReportHeader',
    appendText: '$',
    className: 'flat-rate-class'
  },
  {
    name: 'Expense Amount',
    key: 'expenseAmount',
    format: 'MoneyNumber',
    // format: 'ReportHeader',
    appendText: '$',
    className: 'flat-rate-class'
  },
  {
    name: 'Burden Amount',
    key: 'burdenAmount',
    format: 'MoneyNumber',
    // format: 'ReportHeader',
    appendText: '$',
    className: 'flat-rate-class'
  }
];

export const extendibleMarketArray2 = [
  {
    name: 'Allocation Percent',
    key: 'allocationRate',
    format: 'DecimalPercent',
    // format: 'ReportHeader',
    appendText: '%',
    hideColumn: true
  },
  {
    name: 'Burden Rate Percent',
    key: 'burdenRatePercent',
    format: 'DecimalPercent',
    // format: 'ReportHeader',
    appendText: '%',
    className: 'burden-rate-percent-class',
    hideColumn: true
  },
  {
    name: 'Billing Percent',
    key: 'propertyBillingPercent',
    format: 'DecimalPercent',
    // format: 'ReportHeader',
    appendText: '%',
    className: 'billing-percent-class',
    hideColumn: true
  },
  {
    name: 'Flat Rate',
    key: 'flatrate',
    format: 'MoneyNumber',
    // format: 'ReportHeader',
    appendText: '$',
    className: 'flat-rate-class'
  },
  {
    name: 'Expense Amount',
    key: 'expenseAmount',
    format: 'MoneyNumber',
    // format: 'ReportHeader',
    appendText: '$',
    className: 'flat-rate-class'
  },
  {
    name: 'Burden Amount',
    key: 'burdenAmount',
    format: 'MoneyNumber',
    // format: 'ReportHeader',
    appendText: '$',
    className: 'flat-rate-class'
  },
  {
    name: 'Reimbursement Cost',
    key: 'reimbursementCost',
    format: 'DecimalPercent',
    appendText: '$'
  }
];

export const extendibleMarketArray1 = [
  {
    name: 'Allocation Percent',
    key: 'allocationRate',
    format: 'DecimalPercent',
    // format: 'ReportHeader',
    appendText: '%'

  },
  {
    name: 'Burden Rate Percent',
    key: 'burdenRatePercent',
    format: 'DecimalPercent',
    // format: 'ReportHeader',
    appendText: '%',
    className: 'burden-rate-percent-class'
  },
  {
    name: 'Billing Percent',
    key: 'propertyBillingPercent',
    format: 'DecimalPercent',
    // format: 'ReportHeader',
    appendText: '%',
    className: 'billing-percent-class'
  },
  {
    name: 'Flat Rate',
    key: 'flatrate',
    format: 'MoneyNumber',
    // format: 'ReportHeader',
    appendText: '$',
    className: 'flat-rate-class'
  },
  {
    name: 'Expense Amount',
    key: 'expenseAmount',
    format: 'MoneyNumber',
    // format: 'ReportHeader',
    appendText: '$',
    className: 'flat-rate-class'
  },
  {
    name: 'Burden Amount',
    key: 'burdenRateAmount',
    format: 'MoneyNumber',
    // format: 'ReportHeader',
    appendText: '$',
    className: 'flat-rate-class'
  }
];

export const employeeOvertimeColumnList = [
  {
    name: 'Work Date',
    key: 'otDate',
    type: 'Child',
    isRequired: false,
    isVisible: true,
    editSortOrder: 4,
    dataFormat: 'Date',
    editConfig: {
      type: 'DatePicker',
      isEditField: false,
      isAddField: true
    }
  },
  {
    name: 'Pay Date',
    key: 'payDate',
    type: 'Child',
    isRequired: true,
    isVisible: true,
    editSortOrder: 4,
    dataFormat: 'Date',
    editConfig: {
      type: 'DatePicker',
      isEditField: true,
      isAddField: true
    }
  },
  {
    name: 'Employee Name',
    key: 'employeeName',
    type: 'Child',
    isRequired: true,
    isVisible: true,
    editSortOrder: 1,
    editConfig: {
      type: 'DropDown',
      sourceKey: 'employeeMasterData',
      updateKey: 'employeeId',
      sourceOption: 'employeeName',
      title: 'Employee Name',
      isEditField: true,
      isAddField: true
    }
  },
  {
    name: 'Market Name',
    key: 'marketName',
    type: 'Child',
    isRequired: true,
    isVisible: true,
    editSortOrder: 1,
    editConfig: {
      type: 'DropDown',
      sourceKey: 'marketMasterData',
      updateKey: 'marketId',
      sourceOption: 'marketName',
      title: 'Market Name',
      isEditField: true,
      isAddField: true
    }
  },
  {
    name: "Property Name",
    key: "propertyName",
    type: "Child",
    fieldId: 'propertyId',
    isRequired: true,
    isVisible: true,
    editSortOrder: 10,
    editConfig: {
      type: 'DropDown',
      sourceKey: 'propertyMasterData',
      updateKey: 'propertyId',
      sourceOption: 'propertyName',
      title: 'Property Name',
      isEditField: true,
      isAddField: true
    },
    filterSourceOn: [
      { key: 'marketId', filterBy: 'marketId' }
    ]
  },
  {
    name: "Hours",
    key: "otHours",
    type: "Child",
    isRequired: true,
    isVisible: true,
    editSortOrder: 6,
    editConfig: {
      type: 'TextField',
      isEditField: true,
      isAddField: true
    }
  },
  {
    name: "Additional Regular Hours",
    key: "additionalRegHours",
    type: "Child",
    isRequired: true,
    isVisible: true,
    editSortOrder: 6,
    editConfig: {
      type: 'TextField',
      isEditField: true,
      isAddField: true
    }
  },
  {
    name: "Comment",
    key: "comments",
    type: "Child",
    editSortOrder: 25,
    isRequired: true,
    isVisible: true,
    editConfig: {
      type: 'TextField',
      isEditField: true,
      isAddField: true
    }
  },
  // {
  //   name: "Status",
  //   key: "status",
  //   type: "Child"
  // },

  {
    name: 'Action',
    key: 'marketId',
    type: 'Child',
    editSortOrder: 301,
    renderComponent: 'renderActionColumn',
    minWidth: 90
  }
];

export const employeeSuperVisorOvertimeColumn = [
  {
    name: 'Date',
    key: 'otDate',
    type: 'Child',
    isRequired: false,
    isVisible: true,
    editSortOrder: 4,
    dataFormat: 'Date',
    editConfig: {
      type: 'DatePicker',
      isEditField: false,
      isAddField: false
    }
  },
  {
    name: 'Market',
    key: 'marketName',
    type: 'Child',
    isRequired: true,
    isVisible: true,
    editSortOrder: 1,
    editConfig: {
      type: 'DropDown',
      sourceKey: 'marketMasterData',
      updateKey: 'marketId',
      sourceOption: 'marketName',
      title: 'Market Name',
      isEditField: true,
      isAddField: true
    }
  },
  {
    name: 'Employee',
    key: 'employeeName',
    type: 'Child',
    minWidth: 200,
    isRequired: true,
    isVisible: true,
    editConfig: {
      type: 'TextField',
      isEditField: false,
      isAddField: false
    }
  },
  {
    name: "Property Name",
    key: "propertyName",
    type: "Child",
    fieldId: 'propertyId',
    isVisible: true,
    editSortOrder: 10,
    editConfig: {
      type: 'DropDown',
      sourceKey: 'propertyMasterData',
      updateKey: 'propertyId',
      sourceOption: 'propertyName',
      title: 'Property Name',
      isEditField: true,
      isAddField: true
    }
  },
  {
    name: "Hours",
    key: "otHours",
    type: "Child",
    isRequired: true,
    isVisible: true,
    editSortOrder: 6,
    editConfig: {
      type: 'TextField',
      isEditField: true,
      isAddField: true
    }
  },
  {
    name: "Comment",
    key: "comments",
    type: "Child",
    editSortOrder: 25,
    isRequired: true,
    isVisible: true,
    editConfig: {
      type: 'TextField',
      isEditField: true,
      isAddField: true
    }
  },
  {
    name: "Status",
    key: "status",
    type: "Child"
  },

  {
    name: 'Action',
    key: 'marketId',
    type: 'Child',
    editSortOrder: 301,
    renderComponent: 'renderActionColumn',
    minWidth: 90
  }
];

export const overTimeConfig = {
  collapsible: false,
  groupBy: 'employeeOvertimeId',
  inLineGroupBlock: false,
  showPager: true
};

export const billingAdjustmentsColumns = [
  { name: 'Employee Name', key: 'employeeName', type: 'Parent' },
  { name: 'Pay Period', key: 'payPeriod', type: 'Parent' },
  { name: 'Pay Code', key: 'payCode', type: 'Parent' },
  { name: 'Reimbursement', key: 'reimbursement', type: 'Parent' },
  { name: 'Amount', key: 'originalAmount', type: 'Parent', dataFormat: 'MoneyDecimal' },
  { name: 'Split', key: 'splitType', type: 'Parent' },
  { name: 'Adjustment Value', key: 'adjustmentValue', type: 'Parent', dataFormat: 'NewLineText' },
  {
    name: 'Action',
    key: 'marketId',
    type: 'Child',
    editSortOrder: 301,
    renderComponent: 'renderActionColumn',
    minWidth: 90
  }
];

export const billingAdjustmentsConfig = {
  collapsible: false,
  inLineGroupBlock: false,
  showPager: true,
  groupBy: 'employeeId'
};

export const billingAdjustmentColumn = [
  { name: 'Employee Name', key: 'employeeName', type: 'Parent', dataFormat: 'Text', hideWhen: [{ key: 'payCodeTypeId', value: 4 }], minWidth: '120px' },
  { name: 'Market', key: 'marketName', ignoreFilter: true, isEditable: true, sourceData: 'originalMarketData', idKey: 'marketId', type: 'Parent', dataFormat: 'Text', hiddenKey: 'allocationType', hideWhen: [{ key: "allocationType", value: "Property OT" }, { key: "allocationType", value: "Property Billing" }], showWhen: [{ key: 'payCodeTypeId', value: 4 }], minWidth: '120px' },
  { name: 'Division', key: 'division', cascaded: 'marketId', cascaded1: 'divisionId', ignoreFilter: false, isEditable: true, sourceData: 'originalDivisionData', idKey: 'divisionId', type: 'Parent', dataFormat: 'Text', hiddenKey: 'allocationType', hideWhen: [{ key: "allocationType", value: "Property OT" }, { key: "allocationType", value: "Property Billing" }], showWhen: [{ key: 'payCodeTypeId', value: 4 }], minWidth: '120px' },
  { name: 'Department', key: 'departmentName', cascaded: 'marketId', cascaded1: 'divisionId', ignoreFilter: false, isEditable: true, sourceData: 'originalDepartmentData', idKey: 'departmentId', type: 'Parent', dataFormat: 'Text', hiddenKey: 'allocationType', hideWhen: [{ key: "allocationType", value: "Property OT" }, { key: "allocationType", value: "Property Billing" }], showWhen: [{ key: 'payCodeTypeId', value: 4 }], minWidth: '120px' },
  { name: 'Property', key: 'propertyName', ignoreFilter: false, isEditable: true, sourceData: 'originalPropertyMasterData', idKey: 'propertyId', type: 'Parent', dataFormat: 'Text', hiddenKey: 'allocationType', hideWhen: [{ key: "allocationType", value: "Market" }], showWhen: [{ key: 'payCodeTypeId', value: 4 }], minWidth: '120px' },
  { name: 'Allocation %', key: 'allocationPercent', dataFormat: 'DecimalPercent', type: 'Parent', showWhen: [{ key: 'payCodeTypeId', value: 4 }], minWidth: '100px' },
  { name: 'Burden Rate', key: 'burdenRate', dataFormat: 'DecimalPercent', hiddenKey: 'allocationType', hideWhen: [{ key: "allocationType", value: "Market" }], type: 'Parent', showWhen: [{ key: 'payCodeTypeId', value: 4 }], minWidth: '100px' },
  { name: 'Multiplier', key: 'multiplier', type: 'Parent', dataFormat: 'Number', hiddenKey: 'allocationType', hideWhen: [{ key: "allocationType", value: "Market" }, { key: "allocationType", value: "Property Billing" }], showWhen: [{ key: 'payCodeTypeId', value: 4 }], minWidth: '100px' },
  { name: 'OVERTIME Pay Rate', key: 'overtimePayRate', type: 'Parent', dataFormat: 'Number', hiddenKey: 'allocationType', hideWhen: [{ key: "allocationType", value: "Market" }, { key: "allocationType", value: "Property Billing" }], showWhen: [{ key: 'payCodeTypeId', value: 4 }], minWidth: '100px' },
  { name: 'ADDL REG Pay Rate', key: 'addlRegPayRate', type: 'Parent', dataFormat: 'Number', hiddenKey: 'allocationType', hideWhen: [{ key: "allocationType", value: "Market" }, { key: "allocationType", value: "Property Billing" }], showWhen: [{ key: 'payCodeTypeId', value: 4 }], minWidth: '100px' },
  { name: 'Gross Amount', key: 'grossAmount', dataFormat: 'MoneyDecimal', type: 'Parent', showWhen: [{ key: 'payCodeTypeId', value: 4 }], minWidth: '100px', hideWhen: [{ key: 'payCodeTypeId', value: 4 }, { key: "allocationType", value: "Property OT" }, { key: "allocationType", value: "Property Billing" }], sumOfAdjustableGross: true, hiddenKey: 'allocationType' },
  { name: 'Adjustment %', key: 'adjustmentPercent', dataFormat: 'DecimalPercent', type: 'Parent', showWhen: [{ key: 'payCodeTypeId', value: 4 }], minWidth: '100px', hideWhen: [{ key: 'payCodeTypeId', value: 4 }, { key: "allocationType", value: "Property OT" }, { key: "allocationType", value: "Property Billing" }], isRound: true, hiddenKey: 'allocationType' }
];

export const payCodeListColumn = [
  { key: 'reimbursementAmount', hideWhen: { key: 'splitType', value: 'Amount Split' }, showWhen: { key: 'splitType', value: 'Percent Split' }, dataFormat: 'MoneyDecimal', appendText: '', className: 'amount-value text-right-alignment' },
  { key: 'splitPercent', hideWhen: { key: 'splitType', value: 'Percent Split' }, showWhen: { key: 'splitType', value: 'Percent Split' }, dataFormat: 'DecimalPercent', appendText: '%', className: 'percent-value text-right-alignment' }
];

export const overtimeListColumn = [
  { key: 'reimbursementAmount', hideWhen: { key: 'splitType', value: 'Amount Split' }, showWhen: { key: 'splitType', value: 'Percent Split' }, dataFormat: 'MoneyDecimal', appendText: '', className: 'amount-value text-right-alignment' },
  { key: 'splitPercent', hideWhen: { key: 'splitType', value: 'Percent Split' }, showWhen: { key: 'splitType', value: 'Percent Split' }, dataFormat: 'DecimalPercent', appendText: '%', className: 'percent-value text-right-alignment' }
];

export const closePayCycleColumn = [
  { name: 'Pay Period', key: 'payPeriod', type: 'Parent' },
  { name: 'Period Start Date', key: 'periodStartDate', type: 'Parent' },
  { name: 'Period End Date', key: 'periodEndDate', type: 'Parent' },
  { name: 'Is Closed', key: 'isClosed', type: 'Parent' },
  { name: 'Closed By', key: 'closedBy', type: 'Parent' },
  { name: 'Closed Date', key: 'closedDate', type: 'Parent' },
  {
    name: 'Action',
    key: 'clientId',
    type: 'Child',
    renderComponent: 'renderActionColumn',
    minWidth: 80
  }
];

export const complianceColumn = [
  { name: 'Employee Name', key: 'employeeName', type: 'Parent' },
  { name: 'Email', key: 'userEmail', type: 'Parent' },
  { name: 'Period Start Date', key: 'periodStartDate', type: 'Parent' },
  { name: 'Period End Date', key: 'periodEndDate', type: 'Parent' },
  // { name: 'Allocations Due Date', key: 'allocationDueDate', type: 'Parent' },
  { name: 'Is Completed', key: 'isCompleted', type: 'Parent' },
  { name: 'Completed By', key: 'completedBy', type: 'Parent' },
  { name: 'Completed Date', key: 'completedDate', type: 'Parent' },
  { name: 'Completion Status', key: 'complianceStatus', type: 'Parent' },
  // { name: 'Allocation Change Count After Completion', key: 'postCompletionRecordCount', type: 'Parent' },
  {
    name: 'Action',
    key: 'clientId',
    type: 'Child',
    renderComponent: 'renderActionColumn',
    minWidth: 80
  }
];

export const sdcDesignationTitleColumnsList = [
  {
    name: 'PMA Title',
    key: 'pmaTitle',
    type: 'Child',
    isRequired: true,
    isVisible: true,
    fieldId: 'pmaTitleId',
    editSortOrder: 2,
    editConfig: {
      type: 'TextField',
      // sourceKey: 'pmaTitleMasterData',
      // updateKey: 'pmaTitleId',
      // sourceOption: 'pmaTitle',
      // title: 'pmaTitle',
      isEditField: true,
      isAddField: true
      // distinctOn: "pmaTitle"
    }
  },
  {
    name: 'Parent PMA Title',
    key: 'parentPmaTitle',
    isRequired: false,
    isVisible: true,
    fieldId: 'parentPmaTitleId',
    editSortOrder: 2,
    editConfig: {
      type: 'DropDown',
      sourceKey: 'sdcMasterPMATitles',
      updateKey: 'parentPmaTitleId',
      sourceOption: 'parentPmaTitle',
      title: 'parentPmaTitleId',
      isEditField: true,
      isAddField: true,
      multiple: false,
      delimiter: '|'
    }
  },
  // {
  //   name: 'Employee Job Title',
  //   key: 'designation',
  //   isRequired: true,
  //   isVisible: true,
  //   fieldId: 'designationId',
  //   editSortOrder: 2,
  //   editConfig: {
  //     type: 'DropDown',
  //     sourceKey: 'designationMasterData',
  //     updateKey: 'designationId',
  //     sourceOption: 'designation',
  //     title: 'designation',
  //     isEditField: true,
  //     isAddField: true,
  //     multiple: true,
  //     delimiter: '|'
  //   }
  // },
  // {
  //   name: 'Applicable From',
  //   key: 'startDate',
  //   type: 'Child',
  //   dataFormat: 'Date',
  //   isRequired: true,
  //   isVisible: true,
  //   editConfig: {
  //     type: 'DatePicker',
  //     isEditField: true,
  //     isAddField: true,
  //     shouldDisableDate: disableDatesForPayCycleStart1
  //   }
  // },
  // {
  //   name: 'Applicable Till',
  //   key: 'endDate',
  //   type: 'Child',
  //   dataFormat: 'Date'
  // },
  {
    name: 'Action',
    key: 'designationGroupId',
    renderComponent: 'renderActionColumn',
    minWidth: 80
  }
];

export const propertyTenantMappingColumnList1 = [
  {
    name: 'Market Name',
    key: 'marketName',
    type: 'Parent',
    fieldId: 'marketId',
    isVisible: true,
    isRequired: true,
    isEditable: false
  },
  {
    name: 'Property Name',
    key: 'propertyName',
    type: 'Parent',
    fieldId: 'propertyId',
    isVisible: true,
    isRequired: true,
    isEditable: false
  },
  {
    name: "Tenant Count",
    key: "tenantCount",
    type: "Child",
    editSortOrder: 3,
    isRequired: true,
    isVisible: true,
    isEditable: true,
    dataFormat: 'Number',
    editConfig: {
      type: 'TextNumber',
      isEditField: true,
      isAddField: true,
      isAvoidFormatting: true
    },
    rules: {
      And: [
        {
          operator: Operators.GreaterThan,
          key: '',
          value: -1
        }
      ]
    }
  },
  {
    name: 'Start From',
    key: 'startDate',
    type: 'Child',
    dataFormat: 'Date',
    isRequired: true,
    isVisible: true,
    isEditable: false
  },
  {
    name: 'End Date',
    key: 'endDate',
    type: 'Child',
    dataFormat: 'Date',
    isRequired: false,
    isVisible: true,
    isEditable: false
  },
  {
    name: 'AR Admin',
    key: 'employeeName',
    type: 'Parent',
    isRequired: true,
    isVisible: true,
    fieldId: 'employeeId',
    isEditable: true,
    editSortOrder: 2,
    editConfig: {
      type: 'DropDown',
      sourceKey: 'employeeMasterData',
      updateKey: 'employeeId',
      sourceOption: 'employeeName',
      title: 'employee Name',
      isEditField: true,
      isAddField: true,
      distinctOn: "employeeId"
    }
  },
  {
    name: 'Action',
    key: 'arPropertyTenantMappingId',
    renderComponent: 'renderActionColumn',
    minWidth: 80
  }
];

export const propertyTenantMappingColumnList = [
  {
    id: 'marketName',
    name: 'Market Name',
    label: 'Market Name',
    key: 'marketName',
    type: 'Text',
    fieldId: 'marketId',
    isVisible: true,
    isRequired: true,
    isEditable: false
  },
  {
    id: 'propertyName',
    name: 'Property Name',
    label: 'Property Name',
    key: 'propertyName',
    type: 'Text',
    fieldId: 'propertyId',
    isVisible: true,
    isRequired: true,
    isEditable: false
  },
  {
    id: "tenantCount",
    name: "Tenant Count",
    label: "Tenant Count",
    key: "tenantCount",
    type: "Number",
    editSortOrder: 3,
    isRequired: true,
    isVisible: true,
    isEditable: true,
    dataFormat: 'Number',
    width: '150px',
    editConfig: {
      type: 'TextNumber',
      isEditField: true,
      isAddField: true,
      isAvoidFormatting: true
    },
    rules: {
      And: [
        {
          operator: Operators.GreaterThan,
          key: '',
          value: -1
        }
      ]
    }
  },
  {
    id: 'startDate',
    name: 'Start Date',
    label: 'Start Date',
    key: 'startDate',
    type: 'Text',
    dataFormat: 'Date',
    isRequired: true,
    isVisible: true,
    isEditable: false
  },
  {
    id: 'endDate',
    name: 'End Date',
    label: 'End Date',
    key: 'endDate',
    type: 'Text',
    dataFormat: 'Date',
    isRequired: false,
    isVisible: true,
    isEditable: false
  },
  {
    id: 'employeeName',
    name: 'AR Admin',
    label: 'AR Admin',
    key: 'employeeName',
    type: 'Text',
    isRequired: false,
    isVisible: true,
    fieldId: 'employeeId',
    isEditable: true,
    editSortOrder: 2,
    editConfig: {
      type: controlType.DropDown,
      controlType: controlType.DropDown,
      sourceKey: 'employeeMasterData',
      updateKey: 'employeeId',
      sourceOption: 'employeeName',
      title: 'employee Name',
      isEditField: true,
      isAddField: true,
      distinctOn: "employeeId"
    }
  },
  {
    name: 'Action',
    key: 'arPropertyTenantMappingId',
    renderComponent: 'renderActionColumn',
    minWidth: 80
  }
];

export const sdcLeadershipEmployeeColumnList = [
  {
    name: 'Employee Name',
    key: 'preferredName',
    type: 'Parent',
    fieldId: 'employeeId',
    isVisible: true,
    isRequired: true,
    editSortOrder: 1,
    editConfig: {
      type: 'DropDown',
      sourceKey: 'employeeMasterData',
      updateKey: 'employeeId',
      sourceOption: 'employeeName',
      title: 'Employee Name',
      isEditField: false,
      isAddField: true,
      distinctOn: "employeeId"
    },
    dependentFieldValidation: ['budgetedPercent']

  },
  {
    name: 'PMA Title',
    key: 'pmaTitle',
    type: 'Parent',
    isRequired: true,
    isVisible: true,
    fieldId: 'pmaTitleId',
    editSortOrder: 2,
    editConfig: {
      type: 'DropDown',
      sourceKey: 'pmaTitleMasterData',
      updateKey: 'pmaTitleId',
      sourceOption: 'pmaTitle',
      title: 'pmaTitle',
      isEditField: true,
      isAddField: true,
      distinctOn: "pmaTitle"
    }
  },
  {
    name: "Budgeted %",
    key: "budgetedPercent",
    type: "Child",
    editSortOrder: 3,
    isRequired: true,
    isVisible: true,
    dataFormat: 'DecimalPercent',
    editConfig: {
      type: 'TextNumber',
      isEditField: true,
      isAddField: true,
      isAvoidFormatting: true
    },
    rules: {
      And: [
        {
          operator: Operators.GreaterThan,
          key: '',
          value: 0
        }
      ]
    }
  },
  {
    name: 'Start From',
    key: 'startDate',
    type: 'Child',
    dataFormat: 'Date',
    isRequired: true,
    isVisible: true,
    editConfig: {
      type: 'DatePicker',
      isEditField: true,
      isAddField: true,
      shouldDisableDate: disableDatesForPayCycleStart1
    },
    rules: {
      And: [
        {
          operator: Operators.LessThanEqualsTo,
          key: 'endDate',
          displayName: 'End Date'
        }
      ]
    },
    dependentFieldValidation: ['endDate']
  },
  {
    name: 'End Date',
    key: 'endDate',
    type: 'Child',
    dataFormat: 'Date',
    editSortOrder: 5,
    editConfig: {
      type: 'DatePicker',
      isEditField: true,
      isAddField: true,
      shouldDisableDate: disableDatesForPayCycleEnd1
    },
    rules: {
      And: [
        {
          operator: Operators.GreaterThanEqualsTo,
          key: 'startDate',
          displayName: 'Start Date'
        }
      ]
    },
    dependentFieldValidation: ['startDate']
  },
  {
    name: 'Action',
    key: 'sdcBudgetedPercentConfigurationId',
    renderComponent: 'renderActionColumn',
    minWidth: 80
  }
];

export const empSummaryConfig = [
  {
    attributeName: "MarketName",
    dataFormat: "Text",
    attributeSortOrder: "1",
    isEditable: false,
    isVisible: true,
    dbColumn: "MarketName",
    uiColumn: "Market Name",
    isRequired: false,
    disabled: false
  },
  {
    attributeName: "Client",
    dataFormat: "Text",
    attributeSortOrder: "2",
    isEditable: false,
    isVisible: true,
    dbColumn: "Client",
    uiColumn: "Client",
    isRequired: false,
    disabled: false
  },
  {
    attributeName: "LegalEntity",
    dataFormat: "Text",
    attributeSortOrder: "3",
    isEditable: false,
    isVisible: true,
    dbColumn: "LegalEntity",
    uiColumn: "Legal Entity",
    isRequired: false,
    disabled: false
  },
  {
    attributeName: "ServiceType",
    dataFormat: "Text",
    attributeSortOrder: "4",
    isEditable: false,
    isVisible: true,
    dbColumn: "ServiceType",
    uiColumn: "Service Type",
    isRequired: false,
    disabled: false
  },
  {
    attributeName: "PropertyName",
    dataFormat: "Text",
    attributeSortOrder: "5",
    isEditable: false,
    isVisible: true,
    dbColumn: "PropertyName",
    uiColumn: "Property Name",
    isRequired: false,
    disabled: false
  },
  {
    attributeName: "AccountCode",
    dataFormat: "Text",
    attributeSortOrder: "6",
    isEditable: false,
    isVisible: true,
    dbColumn: "AccountCode",
    uiColumn: "Account Code Name",
    isRequired: false,
    disabled: false
  },
  {
    attributeName: "EmployeeName",
    dataFormat: "Text",
    attributeSortOrder: "7",
    isEditable: false,
    isVisible: true,
    dbColumn: "EmployeeName",
    uiColumn: "Employee",
    isRequired: false,
    disabled: false
  },
  {
    attributeName: "ExpenseGroup",
    dataFormat: "Text",
    attributeSortOrder: "8",
    isEditable: false,
    isVisible: true,
    dbColumn: "ExpenseGroup",
    uiColumn: "Expense Group",
    isRequired: false,
    disabled: false
  },
  {
    attributeName: "ExpenseName",
    dataFormat: "Text",
    attributeSortOrder: "9",
    isEditable: false,
    isVisible: true,
    dbColumn: "ExpenseName",
    uiColumn: "Expense Name",
    isRequired: false,
    disabled: false
  },
  {
    attributeName: "AllocationRate",
    dataFormat: "DecimalPercent",
    attributeSortOrder: "10",
    isEditable: false,
    isVisible: true,
    dbColumn: "AllocationRate",
    uiColumn: "Allocation %",
    isRequired: false,
    disabled: false
  },
  {
    attributeName: "BurdenRatePercent",
    dataFormat: "DecimalPercent",
    attributeSortOrder: "11",
    isEditable: false,
    isVisible: true,
    dbColumn: "BurdenRatePercent",
    uiColumn: "Burden Rate %",
    isRequired: false,
    disabled: false
  },
  {
    attributeName: "PropertyBillingPercent",
    dataFormat: "DecimalPercent",
    attributeSortOrder: "12",
    isEditable: false,
    isVisible: true,
    dbColumn: "PropertyBillingPercent",
    uiColumn: "Billing %",
    isRequired: false,
    disabled: false
  },
  {
    attributeName: "FlatRate",
    dataFormat: "MoneyDecimal",
    attributeSortOrder: "13",
    isEditable: false,
    isVisible: true,
    dbColumn: "FlatRate",
    uiColumn: "Flat Rate",
    isRequired: false,
    disabled: false
  },
  {
    attributeName: "ExpanseAmount",
    dataFormat: "MoneyDecimal",
    attributeSortOrder: "14",
    isEditable: false,
    isVisible: true,
    dbColumn: "ExpanseAmount",
    uiColumn: "Expanse Amount",
    isRequired: false,
    disabled: false
  },
  {
    attributeName: "BurdenAmount",
    dataFormat: "MoneyDecimal",
    attributeSortOrder: "15",
    isEditable: false,
    isVisible: true,
    dbColumn: "BurdenAmount",
    uiColumn: "Burden Amount",
    isRequired: false,
    disabled: false
  }
];

export const empColumn = [
  {
    key: "marketName",
    name: "marketName",
    dataFormat: "Text"
  },
  {
    dataFormat: "Text",
    key: "client",
    name: "client"
  },
  {
    key: "legalEntity",
    name: "legalEntity",
    dataFormat: "Text"
  },
  {
    key: "serviceType",
    name: "serviceType",
    dataFormat: "Text"
  },
  {
    key: "propertyName",
    name: "propertyName",
    dataFormat: "Text"
  },
  {
    key: "accountCode",
    name: "accountCode",
    dataFormat: "Text"
  },
  {
    key: "employeeName",
    name: "employeeName",
    dataFormat: "Text"
  },
  {
    key: "expenseGroup",
    name: "expenseGroup",
    dataFormat: "Text"
  },
  {
    key: "expenseName",
    name: "expenseName",
    dataFormat: "Text"
  },
  {
    key: "allocationRate",
    name: "allocationRate",
    dataFormat: "DecimalPercent"
  },
  {
    key: "burdenRatePercent",
    name: "burdenRatePercent",
    dataFormat: "DecimalPercent"
  },
  {
    key: "propertyBillingPercent",
    name: "propertyBillingPercent",
    dataFormat: "DecimalPercent"
  },
  {
    key: "flatRate",
    name: "flatRate",
    dataFormat: "MoneyDecimal"
  },
  {
    key: "expanseAmount",
    name: "expanseAmount",
    dataFormat: "MoneyDecimal"
  },
  {
    key: "burdenAmount",
    name: "burdenAmount",
    dataFormat: "MoneyDecimal"
  }
];

// Mock column configurations for Overtime Timesheet
export const otTimesheetColumnsList = [
  {
    name: 'Start Date',
    key: 'startDate',
    type: 'Parent',
    isRequired: true,
    isVisible: true,
    fieldId: 'startDate',
    editSortOrder: 1,
    dataFormat: 'Date',
    editConfig: {
      type: 'DatePicker',
      isAddField: true,
      isEditField: true
    },
    rules: {
      And: [
        {
          operator: Operators.LessThan,
          key: 'endDate',
          displayName: 'End Date'
        }
      ]
    }
  },
  {
    name: 'End Date',
    key: 'endDate',
    type: 'Parent',
    isRequired: true,
    isVisible: true,
    fieldId: 'endDate',
    editSortOrder: 2,
    dataFormat: 'Date',
    editConfig: {
      type: 'DatePicker',
      isAddField: true,
      isEditField: true
    },
    rules: {
      And: [
        {
          operator: Operators.GreaterThan,
          key: 'startDate',
          displayName: 'Start Date'
        }
      ]
    }
  },
  {
    name: 'Pay Cycle',
    key: 'payCycle',
    type: 'Parent',
    isRequired: true,
    isVisible: true,
    fieldId: 'payCycle',
    editSortOrder: 3
  },
  {
    name: 'Days in Pay Period',
    key: 'daysInPayPeriod',
    type: 'Parent',
    dataFormat: 'Number',
    isRequired: true,
    isVisible: true,
    fieldId: 'daysInPayPeriod',
    editSortOrder: 4,
    dataFormat: 'Number',
    editConfig: {
    }
  },
  {
    name: 'OT Form Due Date',
    key: 'otFormDueDate',
    type: 'Parent',
    isRequired: true,
    isVisible: true,
    fieldId: 'otFormDueDate',
    editSortOrder: 5,
    dataFormat: 'Date',
    editConfig: {
      type: 'DatePicker',
      isAddField: true,
      isEditField: true
    },
    rules: {
      And: [
        {
          operator: Operators.GreaterThanEqualsTo,
          key: 'endDate',
          displayName: 'End Date'
        },
        {
          operator: Operators.LessThanEqualsTo,
          key: 'payDate',
          displayName: 'Pay Date'
        },
      ]
    }
  },
  {
    name: 'Pay Date',
    key: 'payDate',
    type: 'Parent',
    isRequired: true,
    isVisible: true,
    fieldId: 'payDate',
    editSortOrder: 6,
    dataFormat: 'Date',
    editConfig: {
      type: 'DatePicker',
      isAddField: true,
      isEditField: true
    },
    rules: {
      And: [
        {
          operator: Operators.GreaterThanEqualsTo,
          key: 'otFormDueDate',
          displayName: 'OT Form Due Date'
        }
      ]
    }
  },
  {
    name: 'Is Closed',
    key: 'isClosed',
    type: 'Parent',
    isRequired: true,
    isVisible: true,
    fieldId: 'isClosed',
    editSortOrder: 6,
    dataFormat: 'Boolean'
  }
  // {
  //   name: 'Action',
  //   key: 'otTimesheetId',
  //   renderComponent: 'renderActionColumn',
  //   minWidth: 80
  // }
];

export const bonusAgainstDesignationsColList = [
  {
    name: 'Year',
    key: 'startDate',
    type: 'Child',
    dataFormat: 'Year',
    isRequired: true,
    isVisible: true,
    minDate: '01/01/1900',
    editConfig: {
      type: 'YearPicker',
      isAddField: true,
      isEditField: true,
      shouldDisableDate: disableDatesForPayCycleStart1
    },
    rules: {
      And: [
        {
          operator: Operators.LessThanEqualsTo,
          key: 'endDate',
          displayName: 'End Date'
        }
      ]
    }
    // dependentFieldValidation: ['endDate']
  },
  {
    name: 'Title',
    key: 'designation',
    type: 'Parent',
    isRequired: true,
    isVisible: true,
    fieldId: 'designationId',
    editSortOrder: 2,
    editConfig: {
      type: 'DropDown',
      sourceKey: 'designationMasterData',
      updateKey: 'designationID',
      sourceOption: 'designation',
      title: 'designation',
      isEditField: true,
      isAddField: true,
      distinctOn: "designation"
    }
  },
  {
    name: "Max Bonus Potential %",
    key: "bonusPercent",
    type: "Child",
    editSortOrder: 3,
    isRequired: true,
    isVisible: true,
    dataFormat: 'DecimalPercent',
    editConfig: {
      type: 'TextNumber',
      isEditField: true,
      isAddField: true,
      isAvoidFormatting: true
    },
    rules: {
      And: [
        {
          operator: Operators.GreaterThan,
          key: '',
          value: 0
        },
        {
          operator: Operators.LessThanEqualsTo,
          key: '',
          value: 100
        }
      ]
    }
  },
  {
    name: 'Action',
    key: 'sdcBudgetedPercentConfigurationId',
    renderComponent: 'renderActionColumn',
    minWidth: 80
  }
];

export const employeeBonusSheet = [
  {
    id: 'preferredName',
    key: 'preferredName',
    numeric: false,
    disablePadding: true,
    label: 'Employee Name',
    type: 'Text',
    editSortOrder: 1,
    filterConfig: {
      controlType: controlType.TextBox,
      type: 'text'
    },
    calculatedFieldName: 'bonusAmount',
    calculatedFrom: 'bonusPercent',
    isRequired: true,
    editConfig: {
      type: controlType.DropDown,
      sourceKey: 'employeeMasterData',
      updateKey: 'employeeId',
      sourceOption: 'preferredName',
      dependentFieldValidation: ['bonusPercent'],
      dependentField: ['employeeId', 'marketName', 'marketName', 'departmentId', 'departmentName', 'designationId', 'designation', 'expenseAccountId', 'expenseAccount', 'currentAnnualCompensation', 'bonusPercent', 'burdenRatePercent']
    }
  },
  {
    id: 'marketName',
    key: 'marketName',
    numeric: false,
    disablePadding: true,
    label: 'Market',
    type: 'Text',
    width: '180px',
    editSortOrder: 1,
    filterConfig: {
      controlType: controlType.DropDown,
      type: 'text',
      source: 'marketMasterData',
      key: 'marketName',
      displayFormat: 'MultiText'
    },
    isRequired: true,
    editConfig: {
      type: controlType.DropDown,
      displayFormat: 'MultiText',
      sourceKey: 'marketMasterData',
      updateKey: 'marketId',
      sourceOption: 'marketName',
      dependentFieldValidation: ['bonusPercent']
    }
  },
  {
    id: 'departmentName',
    key: 'departmentName',
    numeric: false,
    disablePadding: true,
    label: 'Department',
    type: 'Text',
    editSortOrder: 2,
    filterConfig: {
      controlType: controlType.DropDown,
      type: 'text',
      source: 'departmentMasterData',
      key: 'departmentName'
    }
  },
  {
    id: 'designation',
    key: 'designation',
    numeric: false,
    disablePadding: true,
    label: 'Title',
    type: 'Text',
    editSortOrder: 2,
    filterConfig: {
      controlType: controlType.DropDown,
      type: 'text',
      source: 'designationMasterData',
      key: 'designation'
    }
  },
  {
    id: 'expenseAccount',
    key: 'expenseAccount',
    numeric: false,
    disablePadding: true,
    label: 'Expense Account',
    type: 'Text',
    editSortOrder: 3,
    filterConfig: {
      controlType: controlType.DropDown,
      type: 'text',
      source: 'accountCodeNameMasterData',
      key: 'accountCode'
    }
  },
  {
    id: 'currentAnnualCompensation',
    key: 'currentAnnualCompensation',
    numeric: false,
    disablePadding: true,
    label: 'Annual Compensation',
    type: 'Number',
    isSort: true,
    editSortOrder: 4
  },
  {
    id: 'isOverride',
    key: 'isOverride',
    type: 'Parent',
    label: 'Is Override',
    editConfig: {
      type: controlType.Badge,
      showBadge: true
    }
  },
  {
    id: 'bonusPercent',
    key: 'bonusPercent',
    numeric: false,
    disablePadding: true,
    label: 'Bonus Percent',
    isSort: true,
    appendText: 'percent',
    calculatedFieldName: 'bonusAmount',
    editSortOrder: 6,
    editConfig: {
      type: controlType.TextNumber,
      renderAlways: true
    },
    rules: {
      And: [
        {
          operator: Operators.LessThanEqualsTo,
          key: '',
          value: 100
        }
      ]
    }
  },
  {
    id: 'bonusAmount',
    key: 'bonusAmount',
    numeric: false,
    disablePadding: true,
    label: 'Bonus Amount',
    appendText: 'amount',
    calculatedFieldName: 'bonusPercent',
    isSort: true,
    editSortOrder: 5,
    editConfig: {
      type: controlType.TextNumber,
      dependentFieldValidation: ['bonusPercent'],
      renderAlways: true
    }
  },
  {
    id: 'burdenRatePercent',
    key: 'burdenRatePercent',
    numeric: false,
    disablePadding: true,
    label: 'Burden Rate Percent',
    type: 'Number',
    isSort: false,
    editSortOrder: 7
  },
  {
    id: 'totalBonusAndBurdenRateAmount',
    key: 'totalBonusAndBurdenRateAmount',
    numeric: false,
    disablePadding: true,
    label: 'Total Bonus And Burden Rate Amount',
    type: 'Number',
    isSort: false,
    editSortOrder: 8
  },
  {
    id: '',
    numeric: false,
    disablePadding: true,
    label: '',
    isSort: false,
    editSortOrder: 9,
    isVisible: true,
    width: '20px',
    renderComponent: 'renderActionColumn'
  }
];

export const employeeBonusAccrualList = [
  {
    id: 'preferredName',
    key: 'preferredName',
    numeric: false,
    disablePadding: true,
    label: 'Employee Name',
    type: 'Text',
    editSortOrder: 2,
    isRequired: true,
    width: '150px',
    filterConfig: {
      controlType: controlType.TextBox,
      type: 'text'
    },
    editConfig: {
      type: controlType.DropDown,
      sourceKey: 'employeeMasterData',
      updateKey: 'employeeId',
      sourceOption: 'preferredName',
      cascaded: 'propertyId',
      cascaded1: 'marketId',
      dependentField: ['employeeId', 'departmentId', 'departmentName', 'designationId', 'designation', 'expenseAccountId', 'expenseAccount', 'totalBonusAndBurdenRateAmount', 'employeeBonusEstimationId', 'legalEntityId', 'marketId', 'marketName'],
      useFormula: true,
      multiplyPercent: 'billingPercent',
      calculatedFrom: 'totalBonusAndBurdenRateAmount',
      calculatedFieldName: ['allocatedBonusAndBurdenRateAmount'],
      calculatedWhen:
      {
        key: 'accrueBillAmount',
        dependentData: {
          key: 'capOrOtherAmount',
          value: ''
        }
      }
    }
  },
  {
    id: 'marketName',
    key: 'marketName',
    numeric: false,
    disablePadding: true,
    label: 'Market',
    type: 'Text',
    editSortOrder: 1,
    isRequired: true,
    width: '150px',
    filterConfig: {
      controlType: controlType.DropDown,
      type: 'text',
      source: 'marketMasterData',
      key: 'marketName'
    },
    editConfig: {
      type: controlType.DropDown,
      sourceKey: 'marketMasterData',
      updateKey: 'marketId',
      sourceOption: 'marketName',
      cascaded: 'propertyId',
      cascaded1: 'employeeId',
      dependentField: ['marketId'],
      clearField: ['propertyId', 'propertyName']
    }
  },
  {
    id: 'propertyName',
    key: 'propertyName',
    numeric: false,
    disablePadding: true,
    label: 'Property',
    type: 'Text',
    editSortOrder: 1,
    isRequired: true,
    width: '150px',
    filterConfig: {
      controlType: controlType.DropDown,
      type: 'text',
      source: 'propertyMasterData',
      key: 'propertyName'
    },
    filterBy: 'marketId',
    editConfig: {
      type: controlType.DropDown,
      sourceKey: 'propertyMasterData',
      updateKey: 'propertyId',
      sourceOption: 'propertyName',
      cascaded: 'marketId',
      cascaded1: 'employeeId',
      dependentField: ['propertyId']
    }
  },
  {
    id: 'designation',
    key: 'designation',
    numeric: false,
    disablePadding: true,
    label: 'Title',
    type: 'Text',
    editSortOrder: 3,
    filterConfig: {
      controlType: controlType.DropDown,
      type: 'text',
      source: 'designationMasterData',
      key: 'designation'
    }
  },
  {
    id: 'departmentName',
    key: 'departmentName',
    numeric: false,
    disablePadding: true,
    label: 'Department',
    type: 'Text',
    editSortOrder: 5,
    width: '100px',
    filterConfig: {
      controlType: controlType.DropDown,
      type: 'text',
      source: 'departmentMasterData',
      key: 'departmentName'
    }
  },
  {
    id: 'expenseAccount',
    key: 'expenseAccount',
    numeric: false,
    disablePadding: true,
    label: 'Expense Account',
    type: 'Text',
    editSortOrder: 6,
    width: '90px',
    filterConfig: {
      controlType: controlType.DropDown,
      type: 'text',
      source: 'accountCodeNameMasterData',
      key: 'accountCode'
    }
  },
  {
    id: 'isReimbursed',
    key: 'isReimbursed',
    numeric: false,
    disablePadding: true,
    label: 'Billable',
    width: '90px',
    type: 'Text',
    editSortOrder: 8
  },
  {
    id: 'billingPercent',
    key: 'billingPercent',
    numeric: false,
    disablePadding: true,
    label: 'Billing Rate',
    type: 'Number',
    appendText: 'percent',
    editSortOrder: 7,
    rules: {
      And: [
        {
          operator: Operators.LessThanEqualsTo,
          key: '',
          value: 100
        }
      ]
    },
    editConfig: {
      type: controlType.TextNumber,
      useFormula: true,
      multiplyPercent: 'billingPercent',
      calculatedFrom: 'totalBonusAndBurdenRateAmount',
      calculatedFieldName: ['allocatedBonusAndBurdenRateAmount'],
      calculatedWhen:
      {
        key: 'accrueBillAmount',
        dependentData: {
          key: 'capOrOtherAmount',
          value: null
        }
      }
    }
  },
  {
    id: 'totalBonusAndBurdenRateAmount',
    key: 'totalBonusAndBurdenRateAmount',
    numeric: false,
    disablePadding: true,
    label: 'Bonus And Burden Rate',
    type: 'Number',
    editSortOrder: 9
  },
  {
    id: 'allocatedBonusAndBurdenRateAmount',
    key: 'allocatedBonusAndBurdenRateAmount',
    numeric: false,
    disablePadding: true,
    label: 'Allocated Bonus And Burden Rate',
    type: 'Number',
    editSortOrder: 10
  },
  {
    id: 'capOrOtherAmount',
    key: 'capOrOtherAmount',
    numeric: false,
    disablePadding: true,
    label: 'Cap/Other Amount',
    type: 'Number',
    editSortOrder: 11,
    calculatedFieldName: 'accrueBillAmount',
    originalFieldValue: 'allocatedBonusAndBurdenRateAmount',
    showDash: true,
    editConfig: {
      type: controlType.TextNumber,
      renderAlways: true
    }
  },
  {
    id: 'accrueBillAmount',
    key: 'accrueBillAmount',
    numeric: false,
    disablePadding: true,
    label: 'Accrue Bill Amount',
    type: 'Number',
    editSortOrder: 12
  },
  {
    id: 'notes',
    key: 'notes',
    numeric: false,
    disablePadding: true,
    label: 'Notes',
    type: 'Text',
    editSortOrder: 13,
    editConfig: {
      type: controlType.TextBox,
      renderAlways: true
    }
  },
  {
    id: '',
    numeric: false,
    disablePadding: true,
    label: '',
    isSort: false,
    editSortOrder: 9,
    isVisible: true,
    width: '20px',
    renderComponent: 'renderActionColumn'
  }
];

export const yearEndComplianceColumn = [
  { name: 'Employee Name', key: 'employeeName', type: 'Parent' },
  { name: 'Email', key: 'userEmail', type: 'Parent' },
  { name: 'Process Year', key: 'processYear', type: 'Parent' },
  { name: 'Estimation Status', key: 'estimationStatus', type: 'Parent' },
  { name: 'Review  Status', key: 'reviewStatus', type: 'Parent' },
  { name: 'Estimation Date', key: 'estimationDate', type: 'Parent' },
  { name: 'Review Date', key: 'reviewDate', type: 'Parent' },
  {
    name: 'Action',
    key: 'yearEndComplianceStatusId',
    type: 'Child',
    renderComponent: 'renderActionColumn',
    minWidth: 80
  }
];

export const closeYearEndBonusColumn = [
  { name: 'Year', key: 'processYear', type: 'Parent' },
  { name: 'Estimations End Date', key: 'allocationPeriodEndDate', type: 'Parent' },
  { name: 'Review End Date', key: 'processEndDate', type: 'Parent' },
  { name: 'Is Closed', key: 'isClosed', type: 'Parent' },
  { name: 'Closed By', key: 'closedBy', type: 'Parent' },
  { name: 'Closed Date', key: 'closedDate', type: 'Parent' },
  {
    name: 'Action',
    key: 'yearEndBonusConfigurationId',
    type: 'Child',
    renderComponent: 'renderActionColumn',
    minWidth: 80
  }
];

export const arCenterializedPropertyMappingColumn = [
  {
    name: 'Employee',
    key: 'employeeName',
    type: 'Parent',
    fieldId: 'employeeId',
    isRequired: true,
    isVisible: true,
    editSortOrder: 2,
    editConfig: {
      type: 'DropDown',
      sourceKey: 'employeeMasterData',
      updateKey: 'employeeId',
      sourceOption: 'employeeName',
      title: 'Employee Name',
      isAddField: true
    }
  },
  {
    name: 'Property',
    key: 'propertyName',
    minTag: 2,
    viewTagData: 'viewTagData',
    isRequired: true,
    isVisible: true,
    editConfig: {
      type: 'DropDown',
      sourceKey: 'propertyMasterData',
      updateKey: 'propertyId',
      sourceOption: 'propertyName',
      title: 'Property',
      isEditField: true,
      isAddField: true,
      multiple: true,
      delimiter: '|'
    }
  },
  {
    name: 'Action',
    minWidth: 80,
    key: 'marketAccessPermissionId',
    renderComponent: 'renderActionColumn'
  }
];

export const contactRoleColumns = [
  {
    name: 'Role Name',
    key: 'roleName',
    type: 'Child',
    fieldId: 'contactRoleId',
    isRequired: true,
    isVisible: true,
    editSortOrder: 2,
    editConfig: {
      type: 'TextField',
      isEditField: true,
      isAddField: true
    }
  },
  {
    name: 'Action',
    minWidth: 80,
    key: 'contactRoleId',
    renderComponent: 'renderActionColumn'
  }
];


export const cacheRefreshColumns = [
  {
    key: 'refreshedBy',
    name: 'Refreshed By',
    type: 'text',
    isRequired: false,
    isReadOnly: true,
    width: 250
  },
  {
    key: 'refreshedOn',
    name: 'Refreshed On',
    type: 'datetime',
    isRequired: false,
    isReadOnly: true,
    width: 250
  }
];
export const yearEndBonusRadio = [
  {
    value: 'Market'
  },
  {
    value: 'Property'
  },
  {
    value: 'Employee'
  }
];

export const uploadColumns = [
  {
    key: 'designation',
    name: 'Title'
  },
  {
    key: 'maxBonusPotential',
    name: 'Max Bonus Potential'
  },
  {
    key: 'year',
    name: 'Year'
  },
  {
    key: 'reason',
    name: 'Reason'
  }
];
